import React, { useState, useEffect, Fragment, useRef, ChangeEvent, useMemo, InputHTMLAttributes, forwardRef, useCallback } from 'react';
import { Button, Row, Col, Card, CardBody, Label, Badge, Input, InputGroup, Nav, Modal, ModalHeader, ModalBody, Form, FormGroup, UncontrolledTooltip, Table, ModalFooter } from 'reactstrap';
import Select, { SingleValue } from 'react-select';
import classnames from "classnames";
import { ChevronLeft, ChevronRight, Download, Eye, Trash2, X, RefreshCw, Filter } from 'react-feather';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import webservice from '../../../Service/webservice';
import { AesDecrypt, AesEncrypt, keyPromise } from '../../../Service/crypto';
import moment from 'moment-timezone';
// import 'flatpickr/dist/themes/material_blue.css';
import { useNavigate } from 'react-router-dom';
import { saveAs } from 'file-saver'
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../ReaduxToolkit/Hooks';
import { getData, Get_permission } from './store';
import websocket_webservice from '../../../Service/websocket_webservice'
import portaldownload from '../../../assets/Avatar/pdf.svg'
import api from '../../../api';
import { useRealTimeSubscription, MongoChange } from '../../../hooks/useRealTimeSubscription';
import { BotManagerTask, fetchRpaTasks } from '../BotManager/store';

interface DeleteRowData {
    Patientname: string;
    id: string;
    PatientDOB: string;
    Memberid: string;
    CompanyName: string;
    pdf_status: string;

    uploaded_date: string;
    RefId: string;
    Payor_ID: string;
    Provider_NPI: string;
    Payer_ID: string;
    Provider_Name: string;
    Provider_ID: string;
    Payer_Name: string;
    Data_Fetched: string;
    template_creation: string;
    // template_creation: string;
    xml_conversion: string;
    payer_name: string;
}

interface JsonData {
    field: string;
    value?: any;
    before?: any;
    after?: any;
}

interface AuditData {
    Modified: string;
    Action: string;
    JsonData: JsonData[];
    UserName: string;
}
interface IDefaultValues {
    DoB: string;
    firstName: string;
    MiddleName?: string;
    lastName: string;
    Memberid: string;
    PayorID: string;
    ProviderNPI: string;
    ClientName: string;
    Address: string;
    Insurancename: string;
    Subscriber: string;
}

const defaultValues: IDefaultValues = {
    DoB: '',
    firstName: '',
    MiddleName: '',
    lastName: '',
    Memberid: '',
    PayorID: '',
    ProviderNPI: '',
    ClientName: '',
    Insurancename: '',
    Address: '',
    Subscriber: '',
};

interface IClientOption {
    label: string;
    value: string;
}

interface DynamicInputHeader {
    key: string;
    prompt: string;
}

const normalizeBotSteps = (steps: any[] | Record<string, any> | undefined) => {
    if (Array.isArray(steps)) return steps;
    if (steps && typeof steps === 'object') return Object.values(steps);
    return [];
};

const shouldExcludeField = (key: string, prompt: string, multipleFields?: string[]): boolean => {
    const keyLower = key.toLowerCase();
    const promptLower = prompt.toLowerCase();

    // Check for username fields
    const usernameKeywords = ["username", "user name", "user id", "userid", "user_id", "login"];
    const isUsernameField = usernameKeywords.some(keyword =>
        keyLower.includes(keyword) || promptLower.includes(keyword)
    );

    // Check for password fields
    const passwordKeywords = ["password", "pass word", "pass", "pwd", "passcode"];
    const isPasswordField = passwordKeywords.some(keyword =>
        keyLower.includes(keyword) || promptLower.includes(keyword)
    );

    // Check if field is in the 'multiple' array (fields that should not be shown in bulk listing)
    const isMultipleField = multipleFields?.some(field => field === key) || false;

    return isUsernameField || isPasswordField || isMultipleField;
};

const extractDynamicHeaders = (steps: any[] | Record<string, any> | undefined, multipleFields?: string[]): DynamicInputHeader[] => {
    const regex = /\{+([^{}]+?)\}+/g;
    const seen = new Map<string, number>();
    const headers: DynamicInputHeader[] = [];


    // Add default fields for RPA patient bulk upload
    const defaultFields = [
        { key: 'FirstName', prompt: 'First Name' },
        { key: 'LastName', prompt: 'Last Name' },
        { key: 'city', prompt: 'City' },
        { key: 'state', prompt: 'State' },
        { key: 'postal_code', prompt: 'Postal Code' },
        { key: 'patient_type', prompt: 'Patient Type' },
        { key: 'fee_schedule', prompt: 'Fee Schedule' },
        { key: 'insurance_network', prompt: 'Insurance Network' }
    ];

    defaultFields.forEach(field => {
        // Only add default fields if they're not in the multiple fields array
        if (!multipleFields?.some(f => f === field.key)) {
            headers.push({
                key: field.key,
                prompt: field.prompt,
            });
            seen.set(field.key, 1);
        }
    });

    normalizeBotSteps(steps).forEach((step: any) => {
        const prompt = step?.prompt || step?.description || '';
        if (!prompt) return;
        const matches = prompt.matchAll(regex);
        for (const match of matches) {
            const baseKey = match[1]?.trim();
            if (!baseKey) continue;

            // Skip username/password fields and multiple fields for RPA clients
            if (shouldExcludeField(baseKey, prompt, multipleFields)) {
                continue;
            }

            // Skip if it's one of our default fields (already added)
            if (['city', 'state', 'postal_code', 'patient_type', 'fee_schedule', 'insurance_network'].includes(baseKey.toLowerCase())) {
                continue;
            }

            const count = seen.get(baseKey) || 0;
            seen.set(baseKey, count + 1);
            headers.push({
                key: count === 0 ? baseKey : `${baseKey}_${count + 1}`,
                prompt,
            });
        }
    });

    return headers;
};

const createEmptyDynamicRow = (headers: DynamicInputHeader[]) => {
    return Object.fromEntries(headers.map((header) => [header.key, '']));
};

const normalizeDynamicRows = (headers: DynamicInputHeader[]) => {
    return headers.length > 0 ? [Object.fromEntries(headers.map((header) => [header.key, '']))] : [];
};

const getAuditFieldRank = (key: string): number => {
    const normalized = key.trim().toLowerCase().replace(/[\s_\/-]+/g, "");

    // 1. First Name
    if (["firstname"].includes(normalized)) return 1;
    // 2. Last Name
    if (["lastname"].includes(normalized)) return 2;
    // 3. Patient DOB
    if (["patientdob", "dob", "dateofbirth"].includes(normalized)) return 3;
    // 4. Member ID
    if (["memberid", "memberidentification"].includes(normalized)) return 4;
    // 5. Provider or Company name
    if (["providerorcompanyname", "providercompanyname"].includes(normalized)) return 5;
    // 6. Provider / Group NPI
    if (["providergroupnpi", "providernpi", "groupnpi", "providerid"].includes(normalized)) return 6;
    // 7. Provider Tax Id
    if (["providertaxid", "providertin"].includes(normalized)) return 7;
    // 8. City
    if (["city"].includes(normalized)) return 8;
    // 9. State
    if (["state"].includes(normalized)) return 9;
    // 10. Zip Code
    if (["zipcode", "zip", "postalcode"].includes(normalized)) return 10;
    // 11. Facility
    if (["facility"].includes(normalized)) return 11;
    // 12. Patient Type
    if (["patienttype", "type"].includes(normalized)) return 12;
    // 13. Subscriber First Name
    if (["subscriberfirstname"].includes(normalized)) return 13;
    // 14. Subscriber Last Name
    if (["subscriberlastname"].includes(normalized)) return 14;
    // 15. Subscriber DOB
    if (["subscriberdob", "subscriberpatientdob", "subscriberdateofbirth"].includes(normalized)) return 15;
    // 16. Subscriber Member Id
    if (["subscribermemberid"].includes(normalized)) return 16;
    // 17. Insurance Network
    if (["insurancenetwork"].includes(normalized)) return 17;
    // 18. Fee Schedule
    if (["feeschedule"].includes(normalized)) return 18;

    // Special: Insurance Name (placed at the end)
    if (["insurancename", "payername", "insurance", "payer"].includes(normalized)) return 2000;
    // Special: Screenshot Status (placed at the end)
    if (["screenshotstatus"].includes(normalized)) return 2001;

    return 1000;
};

const CustomHeader = ({
    handleFilter,
    handlePerPage,
    rowsPerPage,
    toggleModal,
    clientList,
    handleuserclientChange,
    insuranceList,
    handleInsuranceChange,
    handleExpandAll,
    isAllExpanded,
    showFilters,
    setShowFilters,
    value,
    handleFilterClick
}: any) => {

    return (
        <div className="w-100 py-2 px-3 bg-white border rounded d-flex flex-wrap align-items-center gap-2">
            {/* Rows per page */}
            <div className="d-flex align-items-center" style={{ minWidth: "120px" }}>
                <Input
                    id="rows-per-page-select"
                    type="select"
                    value={rowsPerPage}
                    onChange={handlePerPage}
                    className="form-control form-control-sm"
                    style={{ minWidth: "120px", borderRadius: '25px', borderColor: '#4e86e4' }}
                >
                    {[10, 25, 50, 100].map((option) => (
                        <option key={option} value={option}>
                            Rows: {option}
                        </option>
                    ))}
                </Input>
            </div>

            <Button color="info" size="sm" style={{ borderRadius: '25px' }} onClick={toggleModal}>
                Enter Patient Details
            </Button>

            {showFilters && (
                <>
                    {/* Client filter */}
                    <div className="d-flex align-items-center" style={{ minWidth: "200px" }}>
                        <Select
                            isClearable
                            options={clientList}
                            placeholder="Client Filter"
                            onChange={handleuserclientChange}
                            className="react-select w-100"
                            classNamePrefix="select"
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    borderRadius: '25px',
                                    borderColor: '#4e86e4',
                                    minHeight: '31px',
                                }),
                                indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '31px',
                                }),
                            }}
                        />
                    </div>

                    {/* Insurance filter */}
                    <div className="d-flex align-items-center" style={{ minWidth: "200px" }}>
                        <Select
                            isClearable
                            options={insuranceList}
                            placeholder="Insurance Filter"
                            onChange={handleInsuranceChange}
                            className="react-select w-100"
                            classNamePrefix="select"
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    borderRadius: '25px',
                                    borderColor: '#4e86e4',
                                    minHeight: '31px',
                                }),
                                indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '31px',
                                }),
                            }}
                        />
                    </div>
                </>
            )}

            {/* Filter Icon Button */}
            <div className="d-flex align-items-center ms-auto">
                <div
                    onClick={() => setShowFilters(!showFilters)}
                    style={{
                        cursor: 'pointer',
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '5px',
                        marginRight: '10px'
                    }}
                    id="FilterToggle"
                >
                    <Filter size={20} color="#355876" />
                    <div style={{
                        width: 0,
                        height: 0,
                        borderLeft: '5px solid transparent',
                        borderRight: '5px solid transparent',
                        borderTop: '5px solid #FF4D4D',
                        position: 'absolute',
                        bottom: '2px',
                        right: '-2px'
                    }}></div>
                </div>
                <UncontrolledTooltip placement="top" target="FilterToggle">
                    {showFilters ? "Hide Filters" : "Show Filters"}
                </UncontrolledTooltip>
            </div>

            {/* Search */}
            <div style={{ minWidth: "250px" }}>
                <InputGroup size="sm">
                    <Input
                        type="text"
                        placeholder="🔍 Search..."
                        value={value}
                        onChange={(e) => handleFilter(e.target.value)}
                        style={{
                            borderRadius: '25px',
                            borderColor: '#4e86e4',
                            paddingLeft: '12px'
                        }}
                    />
                </InputGroup>
            </div>

            <Button
                color={isAllExpanded ? "danger" : "success"}
                size="sm"
                style={{ borderRadius: '25px' }}
                onClick={handleExpandAll}
            >
                {isAllExpanded ? 'Collapse All' : 'Expand All'}
            </Button>
        </div>
    );
};

const ExpandedComponent = ({ data }: { data: DeleteRowData }) => {
    const [patientData, setPatientData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    // --- REAL-TIME UPDATES FOR PATIENT DETAILS (Inside Expanded View) ---
    // Note: We subscribe to the generic 'BulkuploadPatient' group.
    // In a production app, we might want to filter this by the specific 'BulkUpload' ID (data.id)
    // to avoid unnecessary re-renders for patients belonging to other uploads.
    const handlePatientChange = useCallback((changeData: any) => {
        // Check if the update belongs to the current Bulk Upload ID (data.id)
        // Assuming the patient record has a field linking back to the bulk upload, e.g., 'ParentId' or similar.
        // Based on the screenshot, the patient document has 'ParentId' which matches the BulkUpload ID.

        const parentId = (changeData.fullDocument as any)?.ParentId;
        const currentBulkUploadId = data.id;

        // Note: We cast to String to ensure safe comparison
        if (parentId && String(parentId) !== String(currentBulkUploadId)) {
            // console.log(`DEBUG: Ignoring update for ParentId ${parentId} (Current: ${currentBulkUploadId})`);
            return;
        }

        // Helper to map raw Mongo fields to Table fields
        const mapFields = (doc: any) => {
            return {
                ...doc,
                // Map raw fields to the names expected by the DataTable (replicating API aggregation logic)
                Patientname: doc.Patientname || `${doc.First_Name || ''} ${doc.Last_Name || ''}`.trim(),
                PatientDOB: doc.PatientDOB || doc.Patient_DOB,
                Memberid: doc.Memberid || doc.Member_ID,
                CompanyName: doc.CompanyName || doc.client_name,
                Payer_name: doc.Payer_name || doc.Payer_Name,
                Provider_ID: doc.Provider_ID || doc.Provider_NPI,
                // Add other mappings as needed based on your API response structure
            };
        };

        if (changeData.operationType === 'insert' && changeData.fullDocument) {
            // Add new patient to the list
            const newPatient = {
                ...mapFields(changeData.fullDocument),
                id: (changeData.fullDocument as any)._id
            };
            setPatientData(prev => {
                if (prev.some(item => String(item.id) === String(newPatient.id))) {
                    return prev;
                }
                return [newPatient, ...prev];
            });
            setTotalRows(prev => prev + 1);
        }
        else if (changeData.operationType === 'update' && changeData.documentKey && changeData.updateDescription) {
            const idToUpdate = typeof changeData.documentKey._id === 'object'
                ? (changeData.documentKey._id as any).$oid
                : changeData.documentKey._id;

            setPatientData(prev => prev.map(item => {
                // MongoDB _id might be an object or string in the local state depending on how it was fetched
                const itemId = typeof item._id === 'object' ? item._id.$oid : item._id;

                if (String(itemId) === String(idToUpdate)) {
                    // Merge the raw updates
                    const updatedRaw = { ...item, ...changeData.updateDescription?.updatedFields };
                    // Re-run mapping to update display fields (e.g. if First_Name changed, update Patientname)
                    return mapFields(updatedRaw);
                }
                return item;
            }));
        }
        else if (changeData.operationType === 'delete' && changeData.documentKey) {
            const idToDelete = typeof changeData.documentKey._id === 'object'
                ? (changeData.documentKey._id as any).$oid
                : changeData.documentKey._id;

            setPatientData(prev => prev.filter(item => {
                const itemId = typeof item._id === 'object' ? item._id.$oid : item._id;
                return String(itemId) !== String(idToDelete);
            }));
            setTotalRows(prev => prev - 1);
        }
    }, [data.id, setPatientData, setTotalRows]);

    useRealTimeSubscription('BulkuploadPatient', handlePatientChange, false);

    const columns = [
        { name: 'Uploaded by', selector: (row: any) => row.UserName || 'NA', sortable: true, width: "160px" },
        { name: 'Patient Names', selector: (row: any) => row.Patientname || 'NA', sortable: true, width: "160px" },
        { name: 'Patient DOB', selector: (row: any) => row.PatientDOB || 'NA', sortable: true, width: "160px" },
        { name: 'Member ID', selector: (row: any) => row.Memberid || 'NA', sortable: true, width: "160px" },
        { name: 'Client Name', selector: (row: any) => row.CompanyName || 'NA', sortable: true, width: "160px" },
        { name: 'Insurance Name', selector: (row: any) => row.Payer_name || 'NA', sortable: true, width: "220px" },
        { name: 'Provider ID', selector: (row: any) => row.Provider_ID || 'NA', sortable: true, width: "160px" },
        { name: 'Type', selector: (row: any) => row.Type || 'NA', sortable: true, width: "160px" },
        {
            name: 'Template Generation Time',
            selector: (row: any) => row.template_mapping_time ? `${row.template_mapping_time} sec` : "NA",
            sortable: true, width: "180px"
        },
        {
            name: 'Execution Time',
            selector: (row: any) => row.execution_time ? `${row.execution_time} min` : "NA",
            sortable: true, width: "150px"
        },
        {
            name: 'BOT Status',
            selector: (row: any) => {
                if (row.Data_Fetched === 'C') return 'Received';
                if (row.Data_Fetched === 'E') return 'Error';
                if (row.Data_Fetched === 'I') return 'In Progress';
                if (row.Data_Fetched === 'Y') return 'Yet To Start';
                return row.Data_Fetched || 'NA';
            },
            sortable: true, width: "160px"
        },
        {
            name: 'Uploaded Date',
            selector: (row: any) => row.uploaded_date ? moment.utc(row.uploaded_date).tz(moment.tz.guess()).format('MM/DD/YYYY, HH:mm:ss') : 'NA',
            sortable: true, width: "200px"
        },
    ];

    const fetchPatientDetails = useCallback(async (page: number, size: number) => {
        setLoading(true);
        try {
            const key = await keyPromise;
            const dataParams = {
                UserID: data.id,
                q: '',
                page: page,
                perPage: size
            };
            const dataParamsString = JSON.stringify(dataParams);
            const EncParams = await AesEncrypt(key, dataParamsString);

            const response = await api.fetch('api/getPatientDetails', {
                method: 'POST',
                body: JSON.stringify({ EncParams })
            });

            const jsonResponse = await response.json();
            const Response = await AesDecrypt(key, jsonResponse);

            if (Response.response_data && Array.isArray(Response.response_data)) {
                setPatientData(Response.response_data);
                setTotalRows(Response.count || 0);
            } else {
                setPatientData([]);
                setTotalRows(0);
            }
        } catch (error) {
            console.error("Error fetching expanded data:", error);
            setPatientData([]);
            setTotalRows(0);
        } finally {
            setLoading(false);
        }
    }, [data.id]);

    useEffect(() => {
        fetchPatientDetails(currentPage, perPage);
    }, [fetchPatientDetails, currentPage, perPage]);

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage: number, page: number) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };

    return (
        <div className="p-3" style={{ backgroundColor: '#f8f9fa' }}>
            <h5 className="mb-3">Patient Details</h5>
            <DataTable
                columns={columns}
                data={patientData}
                progressPending={loading}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationPerPage={perPage}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                paginationRowsPerPageOptions={[10, 20, 30, 50]}
                noDataComponent="No patient details found"
                dense
                customStyles={{
                    headCells: {
                        style: {
                            backgroundColor: '#355876',
                            color: 'white',
                            fontSize: '14px',
                        },
                    },
                }}
            />
        </div>
    );
};


const Bulkupload: React.FC = () => {
    const { control, handleSubmit, formState: { errors }, reset } = useForm<IDefaultValues>({
        defaultValues,
    });
    const navigate = useNavigate();
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [selectedFileName, setSelectedFileName] = useState<string>("");
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [selectedClientId, setSelectedClientId] = useState<string>('');
    const [selectedClient, setSelectedClient] = useState<string>('');
    const [selectedtemplate, setselectedtemplate] = useState<string>('');
    const [selectedtemplateId, setselectedtemplateId] = useState<string>('');
    const Username = localStorage.UserName;
    const [usertype] = useState<string>(localStorage.UserType);


    const [id, setId] = useState<string>('');

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const toggle = () => setIsOpen(!isOpen);

    const [eventId, setEventId] = useState<DeleteRowData[]>([]);
    const [eventId1, setEventId1] = useState(0);
    const selectedRowsPerPage: { [key: number]: DeleteRowData[] } = useMemo(() => ({}), []);
    // const menuActions = ['add', 'delete'];
    const action = { fromUser: true };
    const dispatch = useAppDispatch()
    const store = useSelector((state: any) => state.BulkUpload)
    const [value, setValue] = useState<string>('');
    const [sort, setSort] = useState<string>('');
    const [sortColumn, setSortColumn] = useState<any>('uploaded_date'); // Example initial sort column
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [rowsPerPage, setRowsPerPage] = useState<number>(10);
    const [loading, setLoading] = useState(false);
    const [Downloading, setDownloading] = useState(false);
    const [clientOptions, setClientOptions] = useState<IClientOption[]>([]);
    const [vendorbasedclientOptions, setvendorbasedclientOptions] = useState<IClientOption[]>([]);
    const [templateOptions, settemplateOptions] = useState<IClientOption[]>([]);
    const [isCardModalOpen, setIsCardModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [Addresseoption, setAddress] = useState<IClientOption[]>([]);
    const [SelectedAddressname, setSelectedAddress] = useState<string>('');
    const [SelectedAddressId, setSelectedAddressId] = useState<string>('');
    const [selectedUploadInsurance, setSelectedUploadInsurance] = useState<string>('');
    const [SelectedBotstatus, setSelectedBotstatus] = useState<string>('');
    const [SelectedSoftwareName, setSelectedSoftwareName] = useState<boolean>(false);
    const [SelectedSoftwareVendor, setSelectedSoftwareVendor] = useState<string>('');
    const [localData, setLocalData] = useState<DeleteRowData[]>(store.data);
    const [selectedClientOption, setSelectedClientOption] = useState<SingleValue<IClientOption>>(null);
    const [filterSelectedInsurance, setFilterSelectedInsurance] = useState<SingleValue<{ label: string, value: string }>>(null);
    const [filterInsuranceOptions, setFilterInsuranceOptions] = useState<{ label: string, value: string }[]>([]);
    const [expandedRows, setExpandedRows] = useState<string[]>([]);
    const [Screenshot_status, setScreenshot_status] = useState("No");
    const [userClient, setclient] = useState<[]>([]);
    const [scrollInnerModal, setScrollInnerModal] = useState<boolean>(false);
    const [filteredAuditData, setFilteredAuditData] = useState<any[]>([]);
    const [refid, setRefid] = useState<string | null>(null);
    const [showFilters, setShowFilters] = useState(false);
    const handleScreenshot_statusChange = (e: any) => {
        setScreenshot_status(e.target.value);
    };

    useEffect(() => {
        if (usertype === 'Vendor') {
            setId(localStorage.getItem('VendorId') || '');
        } else
            if (usertype === 'Client') {
                setId(localStorage.getItem('ClientId') || '');
            }
            else if (usertype === 'MOS') {
                setId(localStorage.getItem('id') || '');
            }
    }, [usertype]);

    const VendorOptions: any = [
        { value: 'AF', label: 'vendor1' },
        { value: 'AX', label: 'vendor2' },
    ]

    useEffect(() => {
        const isProcessing = localStorage.getItem('isBulkUploadProcessing');
        if (isProcessing === 'true') {
            const batchInsuranceName = localStorage.getItem('currentBatchInsuranceName');
            const noOtpInsurances = ['Blue Cross Blue Shield of Texas', 'UCCI', 'Central States'];
            const isNoOtp = noOtpInsurances.includes(batchInsuranceName || '');

            if (isNoOtp) {
                Swal.fire({
                    // title: 'Insurance Verification Platform',
                    html: `
                    <div style="text-align: center;">
                        <span style="color: green; font-weight: bold; font-size: 1.2em;">Patients Added successfully!</span>
                    </div>
                `,
                    icon: 'success',
                    allowOutsideClick: true,
                    allowEscapeKey: true,
                    showConfirmButton: true,
                });
                localStorage.removeItem('isBulkUploadProcessing');
            } else {
                Swal.fire({
                    // title: 'Insurance Verification Platform',
                    html: `
                    <div style="text-align: center;">
                        <span style="color: green; font-weight: bold; font-size: 1.2em;">Patients Added successfully!</span><br/><br/>
                        <span>OTP Authentication in progress for <b>${batchInsuranceName || ''}</b>, please wait...</span><br/><br/>
                        <div style="background-color: #fff3cd; color: #856404; padding: 10px; border-radius: 5px; border: 1px solid #ffeeba; margin-top: 10px;">
                            <strong>⚠️ Warning:</strong> Please do not refresh the page until the authentication process is complete.
                        </div>
                    </div>
                `,
                    icon: 'success',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                    showClass: {
                        popup: 'animate__animated animate__flipInX',
                    },
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
            }
        }
    }, []);

    const [menuActions, setMenuActions] = useState<string>('');
    useEffect(() => {
        if (localStorage.id !== null) {
            dispatch(Get_permission(localStorage.id)).then((response) => {
                const res1 = response.payload;
                const Action = res1[0].Permission.filter(
                    (item: any) => item.MenuKey === "BULKUPLOAD"
                );
                setMenuActions(Action[0].MenuActions);
            });
        }
    }, [localStorage.id])

    // Unified data fetching function with all parameters
    const fetchDataWithParams = useCallback(async (params: {
        q?: string;
        perPage?: number;
        page?: number;
        sort?: string;
        sortColumn?: string;
        payer_name?: string;
        client?: string;
    } = {}) => {
        if (usertype && id !== undefined) {
            const actionResult = await dispatch(
                getData({
                    id,
                    usertype,
                    q: params.q !== undefined ? params.q : value,
                    perPage: params.perPage !== undefined ? params.perPage : rowsPerPage,
                    page: params.page !== undefined ? params.page : currentPage,
                    sort: params.sort !== undefined ? params.sort : sort,
                    sortColumn: params.sortColumn !== undefined ? params.sortColumn : sortColumn,
                    payer_name: params.payer_name !== undefined ? params.payer_name : (filterSelectedInsurance ? filterSelectedInsurance.label : undefined),
                    client: params.client !== undefined ? params.client : (selectedClientOption ? selectedClientOption.label : undefined)
                })
            );
            const payload = actionResult.payload as { data: DeleteRowData[] };
            // Update local state with fetched data if payload exists
            if (payload && payload.data) {
                setLocalData(payload.data);
            } else {
                setLocalData([]);
            }
            setExpandedRows([]); // Clear expanded rows on new data fetch
        }
    }, [dispatch, usertype, id, value, rowsPerPage, currentPage, sort, sortColumn, filterSelectedInsurance, selectedClientOption]);

    const handleuserclientChange = (selectedOption: SingleValue<IClientOption> | null) => {
        setSelectedClientOption(selectedOption);
    };

    const handleInsuranceFilterChange = (selectedOption: SingleValue<{ label: string, value: string }> | null) => {
        setFilterSelectedInsurance(selectedOption);
    };

    const handleFilterClick = () => {
        setCurrentPage(1);
        fetchDataWithParams({ page: 1 });
    };

    // Fetch initial data only once on mount
    useEffect(() => {
        if (usertype && id !== undefined) {
            fetchDataWithParams({});
        }
    }, [usertype, id, fetchDataWithParams]);

    // --- REAL-TIME UPDATES FOR BULK UPLOAD ---
    const handleBulkUploadUpdate = useCallback((data: any) => {
        if (data.operationType === 'insert' && data.fullDocument) {
            // Add new record to the top
            const newRecord = { ...data.fullDocument, id: (data.fullDocument as any)._id };
            setLocalData(prev => {
                const idToCompare = typeof newRecord.id === 'object' ? (newRecord.id as any).$oid : newRecord.id;
                if (prev.some(item => {
                    const itemId = typeof item.id === 'object' ? (item.id as any).$oid : item.id;
                    return String(itemId) === String(idToCompare);
                })) {
                    return prev;
                }
                return [newRecord, ...prev];
            });
        }
        else if (data.operationType === 'update' && data.documentKey && data.updateDescription) {
            // Update existing record
            const idToUpdate = typeof data.documentKey._id === 'object'
                ? (data.documentKey._id as any).$oid
                : data.documentKey._id;

            const updatedFields = data.updateDescription?.updatedFields;

            console.log("Real-time Bulk Upload update:", updatedFields);

            // Check if OTP status is updated to close the loading popup
            if (updatedFields && (updatedFields.otp_status || updatedFields.Data_Fetched === 'E')) {
                if (localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    Swal.close();
                    localStorage.removeItem('isBulkUploadProcessing');
                    localStorage.removeItem('currentBatchInsuranceName');
                    localStorage.removeItem('currentBatchPatientIds');
                }
            }

            setLocalData(prev => prev.map(item => {
                if (String(item.id) === String(idToUpdate)) {
                    return { ...item, ...updatedFields };
                }
                return item;
            }));
        }
        else if (data.operationType === 'delete' && data.documentKey) {
            const idToDelete = typeof data.documentKey._id === 'object'
                ? (data.documentKey._id as any).$oid
                : data.documentKey._id;
            setLocalData(prev => prev.filter(item => String(item.id) !== String(idToDelete)));
        }
    }, [setLocalData]);

    useRealTimeSubscription<DeleteRowData>('bulkupload_updates', handleBulkUploadUpdate, false);

    // --- REAL-TIME UPDATES FOR PATIENT DETAILS ---
    const handlePatientUpdate = useCallback((data: any) => {
        // console.log("Real-time Patient update:", data);
        // This subscription at the top level is mostly for logging or triggering 
        // global refreshes if needed. The actual data update happens in ExpandedComponent.
    }, []);

    useRealTimeSubscription('BulkuploadPatient', handlePatientUpdate, false);

    const handleReloadTable = () => {
        dispatch(
            getData({
                id,
                usertype,
                q: value,
                perPage: rowsPerPage,
                page: currentPage,
                sort,
                sortColumn,
                payer_name: filterSelectedInsurance ? filterSelectedInsurance.label : undefined
            })
        );
    };


    const handleFilter = (val: any) => {
        setValue(val);
        setCurrentPage(1);
        // Make single backend call with updated filter and reset page
        fetchDataWithParams({ q: val, page: 1 });
    }


    const handleClientFilter = (clientName: string) => {
        setValue(clientName);
        setCurrentPage(1);
        // Make single backend call with updated client filter and reset page
        fetchDataWithParams({ q: clientName, page: 1 });
    };


    const handlePerPage = (e: any) => {
        const newPerPage = parseInt(e.target.value);
        setCurrentPage(1);
        setRowsPerPage(newPerPage);
        setExpandedRows([]); // Collapse all expanded rows when rows per page changes
        // Make single backend call with updated perPage and reset page
        fetchDataWithParams({ perPage: newPerPage, page: 1 });
    }

    const handlePagination = (page: any) => {
        const newPage = page.selected + 1;
        setCurrentPage(newPage);
        // Make single backend call with updated page
        fetchDataWithParams({ page: newPage });
    }

    const dataToRender = () => {
        const filters: any = {
            q: value
        }
        const isFiltered = Object.keys(filters).some(function (k) {
            return filters[k].length > 0
        })

        if (localData.length > 0) {
            return localData
        } else if (localData.length === 0 && isFiltered) {
            return []
        } else {
            return store.allData.slice(0, rowsPerPage)
        }
    }


    const handleExpandAll = () => {
        const currentData = dataToRender();
        const allIds = currentData.map((row: any) => row.id);
        const isAllExpanded = currentData.length > 0 && currentData.every((row: any) => expandedRows.includes(row.id));

        if (isAllExpanded) {
            setExpandedRows([]);
        } else {
            setExpandedRows(allIds);
        }
    };

    const handleRowExpandToggled = (expanded: boolean, row: any) => {
        if (expanded) {
            setExpandedRows(prev => [...prev, row.id]);
        } else {
            setExpandedRows(prev => prev.filter(id => id !== row.id));
        }
    };

    const isAllExpanded = dataToRender().length > 0 && dataToRender().every((row: any) => expandedRows.includes(row.id));

    const handleSort = (column: any, sortDirection: any) => {
        setSort(sortDirection);
        setSortColumn(column.sortField);
        // Make single backend call with updated sort parameters
        fetchDataWithParams({ sort: sortDirection, sortColumn: column.sortField });
    }




    const CustomPagination = () => {
        const count = Number(Math.ceil(store.total / rowsPerPage))
        return (
            <ReactPaginate
                previousLabel={<ChevronLeft size={16} />}
                nextLabel={<ChevronRight size={16} />}
                breakLabel="..."
                pageCount={count || 1}
                marginPagesDisplayed={1}
                pageRangeDisplayed={2}
                onPageChange={handlePagination}
                forcePage={currentPage !== 0 ? currentPage - 1 : 0}
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                activeClassName="active"
            />
        )
    }

    useEffect(() => {
        if (usertype !== 'MOS' && usertype !== "Vendor") {
            setSelectedClient(localStorage.getItem('ClientName') || '');
            setSelectedClientId(localStorage.getItem('ClientId') || '');
        }
    }, [usertype]);

    const get_companyname = async () => {
        const response = await api.fetch('api/BulkUpload/companyname', {
            method: 'POST'
        }).then((response) => response.json());
        const key = await keyPromise
        const TempData = await AesDecrypt(key, response);
        return TempData;
    };


    const get_Clients = async () => {
        const UserType = localStorage.UserType;
        const key = await keyPromise
        const Id = localStorage.VendorId;
        let bodyData = {};
        if (UserType === 'MOS') {
            bodyData = { UserType }; // Send UserType only
        } else if (UserType === 'Vendor') {
            bodyData = { UserType, VendorId: Id }; // Send both UserType and VendorId
        }

        // Make the fetch request
        const response = await api.fetch('api/Bulkupload/get-client', {
            method: 'POST',
            body: JSON.stringify(bodyData), // Send the request body
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };


    useEffect(() => {
        const fetchRoleId = async () => {
            const response = await get_Clients();
            const res = response.map((data: any) => ({
                label: data.CompanyName,
                value: data.CompanyName

            }));
            setclient(res);
        }
        fetchRoleId()
    }, []);



    const get_companynamevendorbased = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, { id: localStorage.VendorId });

        const response = await api.fetch('api/BulkUpload/vendorbasedclientOptions', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    }

    const get_Insurances = async () => {
        const key = await keyPromise;
        // Fetch all insurances for generic filter. 
        // If client-specific is needed, logic would be more complex and depend on selectedClient.
        // Assuming global list for now based on 'api/insurancename'
        const response = await api.fetch('api/insurancename', {
            method: 'POST',
            body: JSON.stringify({})
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchInsurances = async () => {
            try {
                const response = await get_Insurances();
                if (Array.isArray(response)) {
                    const options = response.map((item: any) => ({
                        label: item.name,
                        value: item.name
                    }));
                    setFilterInsuranceOptions(options);
                }
            } catch (error) {
                console.error("Error fetching insurances:", error);
            }
        };
        fetchInsurances();
    }, []);

    const handleInsuranceChange = (selectedOption: SingleValue<{ label: string, value: string }> | null) => {
        setFilterSelectedInsurance(selectedOption);
        setCurrentPage(1);
        fetchDataWithParams({ payer_name: selectedOption ? selectedOption.label : '', page: 1 });
    };

    useEffect(() => {
        const vendorbasedfetchRoleId = async () => {
            const response = await get_companynamevendorbased();
            const res = response.map((data: any) => ({
                label: data.CompanyName,
                value: data.id,
            }));
            setvendorbasedclientOptions(res);
        };

        // Fetch the initial data
        vendorbasedfetchRoleId();

        // WebSocket setup
        const socket = new WebSocket(`${websocket_webservice}ws/ClientDropdown/`);

        // socket.onopen = () => console.log('WebSocket connected');
        // socket.onclose = () => console.log('WebSocket closed');
        // socket.onerror = (error) => console.error('WebSocket error:', error);

        socket.onmessage = () => {
            // const change = JSON.parse(event.data);
            // console.log('WebSocket message received:', change);

            // Optionally, re-fetch the data to update the state when a WebSocket message is received
            vendorbasedfetchRoleId();
        };

        // Clean up the WebSocket connection when the component unmounts
        return () => {
            if (socket.readyState === 1) { // <-- This is important
                socket.close();
            }
        }
    }, []);

    useEffect(() => {
        const fetchRoleId = async () => {
            const response = await get_companyname();
            const res = response.map((data: any) => ({
                label: data.CompanyName,
                value: data.id,
            }));
            setClientOptions(res);
        };

        // Fetch the initial data
        fetchRoleId();

        // WebSocket setup
        const socket = new WebSocket(`${websocket_webservice}ws/ClientDropdown/`);

        // socket.onopen = () => console.log('WebSocket connected');
        // socket.onclose = () => console.log('WebSocket closed');
        // socket.onerror = (error) => console.error('WebSocket error:', error);

        socket.onmessage = () => {
            // const change = JSON.parse(event.data);
            // console.log('WebSocket message received:', change);

            // Optionally, re-fetch the data to update the state when a WebSocket message is received
            fetchRoleId();
        };

        // Clean up the WebSocket connection when the component unmounts
        return () => {
            if (socket.readyState === 1) { // <-- This is important
                socket.close();
            }
        }
    }, []);

    const handleSelectClientChange = (selectedOption: SingleValue<IClientOption>) => {
        if (selectedOption) {
            setSelectedClient(selectedOption.label);
            setSelectedClientId(selectedOption.value);

            // Clear address and template when client is changed
            setSelectedAddress(''); // Reset address
            setSelectedAddressId('');
            setAddress([]); // Assuming setAddress is setting address options
            setselectedtemplate(''); // Reset template
            setselectedtemplateId('');
        } else {
            // Reset all fields if no client is selected
            setSelectedClient('');
            setSelectedClientId('');
            setSelectedAddress('');
            setSelectedAddressId('');
            setselectedtemplate('');
            setselectedtemplateId('');
            setAddress([]); // Reset the address options
        }
    };

    const handleSelecttemplateChange = (selectedOption: SingleValue<IClientOption>) => {
        if (selectedOption) {
            setselectedtemplate(selectedOption.label);
            setselectedtemplateId(selectedOption.value);
        } else {

            setselectedtemplate('');
            setselectedtemplateId('');
        }
    };

    const handleAddressChange = (selectedOption: SingleValue<IClientOption>) => {
        if (selectedOption) {
            setSelectedAddress(selectedOption.label);
            setSelectedAddressId(selectedOption.value);
        } else {
            setSelectedAddress('');
            setSelectedAddressId('');
        }
    };

    const handleUploadInsuranceChange = (selectedOption: SingleValue<IClientOption>) => {
        if (selectedOption) {
            const matchedInsurance = insuranceOptions.find((option) => option.value === selectedOption.value);
            const botStatus = matchedInsurance?.bot_status || '';
            const softwareName = matchedInsurance?.SoftwareName || false;
            const softwareVendor = matchedInsurance?.Software_Vendor || '';
            setSelectedUploadInsurance(selectedOption.value);
            setSelectedBotstatus(botStatus);
            setSelectedSoftwareName(softwareName);
            setSelectedSoftwareVendor(softwareVendor);
            setPatients((previous) => previous.map((patient) => ({ ...patient, insurance: selectedOption.value, bot_status: botStatus, SoftwareName: softwareName, Software_Vendor: softwareVendor })));
        } else {
            setSelectedUploadInsurance('');
            setSelectedBotstatus('');
            setSelectedSoftwareName(false);
            setSelectedSoftwareVendor('');
            setPatients((previous) => previous.map((patient) => ({ ...patient, insurance: '', bot_status: '', SoftwareName: false, Software_Vendor: '' })));
        }
    };

    const resetForm = () => {
        setSelectedFile(null);
        setSelectedFileName('');
        setSelectedClient('');
        setSelectedClientId('');
        setselectedtemplate('');
        setselectedtemplateId('');
        setSelectedAddress('');
        setSelectedAddressId('');
        setSelectedUploadInsurance('');
        setSelectedSoftwareName(false);
        setSelectedSoftwareVendor('');
        setAddress([]);
    };

    const handleSave = async () => {

        if (!selectedFile || !selectedClient) {
            Swal.fire({
                icon: 'warning',
                title: 'Insurance Verification Platform',
                text: 'Please Select Client!',
            });
            return;
        }
        if (!selectedFile || !selectedtemplate) {
            Swal.fire({
                icon: 'warning',
                title: 'Insurance Verification Platform',
                text: 'Please Select Template!',
            });
            return;
        }

        setLoading(true);
        const vendorid = (localStorage.UserType === 'Vendor') ? localStorage.VendorId : "";

        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('ClientName', selectedClient);
        formData.append('ClientId', selectedClientId);
        formData.append('template', selectedtemplate);
        formData.append('templateId', selectedtemplateId);
        formData.append('Address', SelectedAddressname);
        formData.append('Payer_name', selectedUploadInsurance);
        formData.append('vendor_id', vendorid);
        formData.append('Uploaded_userid', localStorage.id);
        formData.append('screenshot_status', Screenshot_status);


        try {
            const response = await axios.post(webservice + 'api/bulkupload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            const auditLogData = [
                { field: "File Name", value: selectedFileName },
                { field: "Client Name", value: selectedClient },
                { field: "Template Name", value: selectedtemplate },
                { field: "Insurance Name", value: selectedUploadInsurance },
                { field: "Address", value: SelectedAddressname },
                { field: "Screenshot Status", value: Screenshot_status }
            ];
            const Username = localStorage.getItem('UserName') || '';
            const auditData = { auditLogData, Username };

            if (response.data === 'Success') {
                fetchDataWithParams({});
                // await axios.post(webservice + 'api/BulkUpload/AddauditLogdata', auditData, {
                //     headers: { 'Content-type': 'application/json; charset=UTF-8' }
                // });
                await api.fetch('api/BulkUpload/AddauditLogdata', {
                    method: 'POST',
                    body: JSON.stringify({ auditData })
                }).then((response) => response.json());

                // Reset form and state
                resetForm();
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'File saved successfully!',
                }).then(async () => {
                    toggle();
                    resetForm();
                    setSelectedClient('');
                });
            } else if (response.data === "Uploaded file does not match the sample file's columns.") {
                Swal.fire({
                    icon: 'warning',
                    title: "Uploaded file does not match the sample file's columns.Download sample Template",
                });
                handleReloadTable()
                toggle();
                resetForm();
                setSelectedClient('');
                setLoading(false);
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'Not Uploaded. Please try again!',
                }).then(() => {
                    handleReloadTable()
                    toggle();
                    resetForm();
                    setSelectedClient('');
                    setLoading(false);
                });
            }
        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error occurred!',
                text: 'Please try again later.',
            });
        }
    };

    const downloadTemplate = async () => {
        try {
            const response = await api.fetch(`api/getfile_excel`);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const responseData = await response.json();
            // Check if the file_data key exists
            if (!responseData.file_data) {
                throw new Error('No file data in response');
            }
            // Decode the base64 data
            const byteCharacters = atob(responseData.file_data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            // Create a blob from the byte array
            const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            // Create a temporary URL for the blob and initiate download
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'BulkUpload.xlsx');
            document.body.appendChild(link);
            link.click();
            // Check if the parentNode exists before removing the link
            if (link.parentNode) {
                link.parentNode.removeChild(link);
            }
        } catch (error) {
            console.error('Error downloading file: ', error);
        }
    };

    useEffect(() => {
        const template = async () => {
            if (!selectedClientId) {
                // If selectedClientId is an empty string or falsy, return early
                return;
            }
            try {
                const key = await keyPromise
                const EncParams = await AesEncrypt(key, selectedClientId);
                const response = await api.fetch('api/BulkUpload/template', {
                    method: 'POST',
                    body: JSON.stringify({ EncParams })
                });

                const result = await response.json();
                const decryptedResult = await AesDecrypt(key, result);
                const res = decryptedResult.map((data: any) => ({
                    label: data.file_name,
                    value: data.id,
                }));

                settemplateOptions(res);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        // Fetch the initial template data
        template();

        // WebSocket setup
        const socket = new WebSocket(`${websocket_webservice}ws/Templatedropdown/`);

        // socket.onopen = () => console.log('WebSocket connected');
        // socket.onclose = () => console.log('WebSocket closed');
        // socket.onerror = (error) => console.error('WebSocket error:', error);

        socket.onmessage = () => {
            // const change = JSON.parse(event.data);
            // console.log('WebSocket message received:', change);

            // Re-fetch the data to update the state when a WebSocket message is received
            template();
        };

        // Clean up the WebSocket connection when the component unmounts
        return () => {
            if (socket.readyState === 1) { // <-- This is important
                socket.close();
            }
        }
    }, [selectedClientId]);

    useEffect(() => {
        const loadRpaTasks = async () => {
            try {
                const result = await fetchRpaTasks({ perPage: 500, page: 1, sort: 'desc', sortColumn: 'createdAt', q: '' });
                setRpaTasks(result.data || []);
            } catch {
                setRpaTasks([]);
            }
        };

        loadRpaTasks();
    }, [selectedClientId]);

    useEffect(() => {
        const get_Address = async () => {
            if (!selectedClientId) {
                // If selectedClientId is an empty string or falsy, return early
                return;
            }

            try {
                const key = await keyPromise
                const EncParams = await AesEncrypt(key, selectedClientId);
                const fetchResponse = await api.fetch('api/address', {
                    method: 'POST',
                    body: JSON.stringify({ EncParams })
                });

                const data = await fetchResponse.json();
                const data1 = await AesDecrypt(key, data);

                const res = data1.flatMap((item: any) =>
                    item.Address.map((address: string) => ({
                        label: address,
                        value: address,
                    }))
                );

                setAddress(res);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        // Fetch the initial address data
        get_Address();

        // WebSocket setup
        const socket = new WebSocket(`${websocket_webservice}ws/ClientDropdown/`);

        // socket.onopen = () => console.log('WebSocket connected');
        // socket.onclose = () => console.log('WebSocket closed');
        // socket.onerror = (error) => console.error('WebSocket error:', error);

        socket.onmessage = () => {
            // const change = JSON.parse(event.data);
            // console.log('WebSocket message received:', change);

            // Optionally, re-fetch the data to update the state when a WebSocket message is received
            get_Address();
        };

        // Clean up the WebSocket connection when the component unmounts
        return () => {
            if (socket.readyState === 1) { // <-- This is important
                socket.close();
            }
        }
    }, [selectedClientId]);

    const deleteUpload = async (ids: any[]) => {
        const idsString = JSON.stringify(ids);
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, idsString);
        await api.fetch('api/bulkupload/DeleteBulkupload', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        });
    };

    const DeleteAuditLogdata = async (data: any[]) => {
        data.forEach(item => {
            item.Userid = localStorage.id;
            item.ParentUserId = localStorage.ParentUserId;
        });
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, data);
        const response = await api.fetch('api/bulkupload/deleteauditlog', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then(response => response.json());
        return response;
    };

    const DeleteUpload = async (rows: any) => {
        const ids = rows.map((row: any) => row.id);
        const Data = rows.map((row: any) => ({
            Username,
            RefId: row.RefId,
            Name: row.filename,
        }));

        const deleteRow = async () => {
            Swal.fire({
                title: "Insurance Verification Platform",
                text: "Are you sure do you want to delete?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-danger ms-1",
                },
                buttonsStyling: false,
                allowOutsideClick: false
            })
                .then(async function (result) {
                    if (result.isConfirmed) {
                        await deleteUpload(ids);
                        await DeleteAuditLogdata(Data);
                        // ✅ Remove deleted rows from localData
                        setLocalData(prev => prev.filter(item => !ids.includes(item.id)));
                        fetchDataWithParams({})
                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "Document has been deleted.",
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                            allowOutsideClick: false
                        });
                        handleReloadTable()
                    }
                });
        };
        deleteRow();
    };

    const [isDownloading, setIsDownloading] = useState(null);

    const getallpatientdetails_Zipfile = async (row: any) => {
        setIsDownloading(row.id);
        try {
            const key = await keyPromise
            const EncParams = await AesEncrypt(key, { id: row.id });
            const response = await api.fetch('api/getallpatientdetails_Zipfile', {
                method: 'POST',
                body: JSON.stringify({ EncParams })
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const responseData = await response.json();
            const OutData = await AesDecrypt(key, responseData);

            if (!OutData.file) {
                throw new Error('No file data in response');
            }

            const zipData = Uint8Array.from(atob(OutData.file), (c) => c.charCodeAt(0));
            const blob = new Blob([zipData], { type: "application/zip" });
            const date = new Date();
            const day = ("0" + date.getDate()).slice(-2);
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear();
            const formattedDate = day + month + year;
            saveAs(blob, `${formattedDate}.zip`);
            setIsDownloading(null);
        } catch (error) {
            console.error('Error downloading file:', error);
            setIsDownloading(null);
        }
    };

    const handleDownloadstatus = async (row: any) => {
        // This should log 'id' correctly now
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, { id: row.id }); // Add a non-null assertion here
        const response = await api.fetch('api/Dashboard/UpdateDownloadStatus', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        });
        const responseData = await response.json();
    };

    interface BootstrapCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
        id: string;
    }
    // Handle individual row checkbox change
    const BootstrapCheckbox = forwardRef<HTMLInputElement, BootstrapCheckboxProps>(
        ({ id, ...props }, ref) => (
            <div style={{ position: 'relative', left: '10px' }}>
                <input type='checkbox' id={id} ref={ref} {...props} />
            </div>
        )
    );

    const handleChangecheck = useCallback(
        ({ selectedRows }: any) => {
            const selectedEventIds = [];
            selectedRows.forEach((row: any) => {
                selectedEventIds.push(row.id);
            });
            setEventId(selectedRows)
            setEventId1(selectedEventIds.length)
            if (!action.fromUser)
                return;
            selectedRowsPerPage[currentPage] = selectedRows;
        },
        [currentPage, selectedRowsPerPage, action.fromUser]);
    const toggleCardModalOpen = () => {
        setIsCardModalOpen(!isCardModalOpen);
    };

    const handleAssign = async (row: any) => {
        setSelectedRow(row);
        setIsCardModalOpen(true);
    };

    const handleAssignVendor = async () => {
        setIsCardModalOpen(false);
    };

    const handlePortalsPDFDocument = async (id: any, row: any) => {
        setDownloading(true);
        try {
            // 1. derive your AES key
            const key = await keyPromise;

            // 2. encrypt the payload with the row.id
            const EncParams = await AesEncrypt(key, { id: row.id });

            // 3. POST to your backend
            const response = await api.fetch('api/getallportalpdf_Zipfile', {
                method: 'POST',
                body: JSON.stringify({ EncParams }),
            });
            if (!response.ok) {
                throw new Error(`Network error: ${response.status}`);
            }

            // 4. parse JSON and decrypt
            const responseData = await response.json();
            const OutData = await AesDecrypt(key, responseData);

            if (!OutData.file) {
                throw new Error('No file payload received');
            }

            // 5. convert base64 → Uint8Array → Blob
            const zipData = Uint8Array.from(atob(OutData.file), c => c.charCodeAt(0));
            const blob = new Blob([zipData], { type: 'application/zip' });

            // 6. build a safe filename
            const rawName = row.filename || 'download';
            const baseName = rawName.includes('.')
                ? rawName.slice(0, rawName.lastIndexOf('.'))
                : rawName;
            const now = new Date();
            const formattedDate = [
                (`0${now.getDate()}`).slice(-2),
                (`0${now.getMonth() + 1}`).slice(-2),
                now.getFullYear()
            ].join('');
            saveAs(blob, `${baseName}_${formattedDate}.zip`);

        } catch (error) {
            console.error('Error downloading file:', error);
            // you might also toast/snackbar the error here
        } finally {
            setDownloading(false);
        }
    };

    const handleRestartDataFetch = async (row: any) => {
        try {
            const result = await Swal.fire({
                title: "Insurance Verification Platform",
                text: "Are you sure you want to restart data fetching for this bulk upload?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Restart",
                cancelButtonText: "Cancel",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-danger ms-1",
                },
                buttonsStyling: false,
                allowOutsideClick: false
            });

            if (result.isConfirmed) {
                const key = await keyPromise;
                const EncParams = await AesEncrypt(key, { id: row.id });

                const response = await api.fetch('api/bulkupload/RestartDataFetch', {
                    method: 'POST',
                    body: JSON.stringify({ EncParams })
                });

                const responseData = await response.json();
                const decryptedData = await AesDecrypt(key, responseData);

                if (decryptedData.status === 'success') {
                    Swal.fire({
                        icon: "success",
                        title: "Insurance Verification Platform",
                        text: "Data fetch has been restarted successfully.",
                        customClass: {
                            confirmButton: "btn btn-success",
                        },
                        allowOutsideClick: false
                    });

                    // Refresh the table data
                    fetchDataWithParams({});
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Insurance Verification Platform",
                        text: "Failed to restart data fetch. Please try again.",
                        customClass: {
                            confirmButton: "btn btn-danger",
                        },
                        allowOutsideClick: false
                    });
                }
            }
        } catch (error) {
            console.error('Error restarting data fetch:', error);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred. Please try again.",
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false
            });
        }
    };


    const toggleRow = (row: any, e: any) => {
        e.stopPropagation();
        const isExpanded = expandedRows.includes(row.id);
        if (!isExpanded) {
            setExpandedRows(prev => [...prev, row.id]);
        } else {
            setExpandedRows(prev => prev.filter(id => id !== row.id));
        }
    };

    const Columns = [
        {
            name: (
                <div className="d-flex justify-content-center w-100 align-items-center">
                    <span onClick={(e) => { e.stopPropagation(); handleExpandAll(); }} style={{ cursor: 'pointer' }}>
                        {isAllExpanded ? <ChevronRight className="rotate-90" size={15} /> : <ChevronRight size={15} />}
                    </span>
                </div>
            ),
            cell: (row: any) => (
                <div className="d-flex justify-content-center w-100 align-items-center">
                    <span onClick={(e) => toggleRow(row, e)} style={{ cursor: 'pointer' }}>
                        {expandedRows.includes(row.id) ? <ChevronRight className="rotate-90" size={15} /> : <ChevronRight size={15} />}
                    </span>
                </div>
            ),
            width: "50px",
            sortable: false,
        },
        {
            name: 'Uploaded by',
            selector: (row: any) => row.UserName !== '' ? row.UserName : 'NA',
            sortable: true,
            filter: true,
            width: "160px",
            filterType: 'text',
        },
        {
            name: 'Client Name',
            selector: (row: any) => row.CompanyName !== '' ? row.CompanyName : 'NA',
            sortable: true,
            filter: true,
            width: "160px",
            wrap: true,
            filterType: 'select', // Use select filter type for dropdown input
            // Pass filter options to the filterValue method
            filterValue: (row: any) => clientOptions.find(option => option.value === row.CompanyName)?.label || 'NA',
        },
        {
            name: 'Template Name',
            selector: (row: any) => row.template !== '' ? row.template : 'NA',
            sortable: true,
            filter: true,
            width: "180px",
            filterType: 'select', // Use select filter type for dropdown input
            // Pass filter options to the filterValue method
            filterValue: (row: any) => clientOptions.find(option => option.value === row.template)?.label || 'NA',
        },
        {
            name: 'Insurance Name',
            selector: (row: any) => row.payer_name || row.Payer_Name || 'NA',
            sortable: true,
            filter: true,
            width: "240px",
            filterType: 'text',
            cell: (row: any) => {
                const name = row.payer_name || row.Payer_Name || 'NA';
                return (
                    <div
                        id={`insurance-name-${row.id}`}
                        style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        {row.LogoUrl && (
                            <img
                                src={row.LogoUrl}
                                alt="Logo"
                                style={{ width: '60px', height: '60px', objectFit: 'contain', marginRight: '10px' }}
                            />
                        )}
                        <span>{name}</span>
                        <UncontrolledTooltip
                            placement="top"
                            target={`insurance-name-${row.id}`}
                            style={{ backgroundColor: "#355876", color: "white" }}
                        >
                            {name}
                        </UncontrolledTooltip>
                    </div>
                );
            }
        },
        {
            name: (
                <> Uploaded Date <br />and Time</>
            ),
            sortable: true,
            filter: true,
            filterType: 'custom',
            customFilterDateParse: (dateStr: string) => new Date(dateStr).toISOString(),
            cell: (row: any) => {
                const dateText = row.uploaded_date
                    ? moment.utc(row.uploaded_date)
                        .tz(moment.tz.guess())
                        .format('MM/DD/YYYY')
                    : 'NA';
                const timeText = row.uploaded_date
                    ? moment.utc(row.uploaded_date)
                        .tz(moment.tz.guess())
                        .format('HH:mm:ss')
                    : '';
                return (
                    <div style={{ textAlign: 'left' }}>
                        <div>{dateText}</div>
                        <div style={{ color: '#6c757d', fontSize: '11px' }}>{timeText}</div>
                    </div>
                );
            }
        },
        {
            name: (
                <div style={{ textAlign: 'center', width: '100%' }}> Patient Count / <br /> Status</div>
            ),
            sortable: true,
            filter: true,
            width: "160px",
            filterType: 'text',
            cell: (row: any) => (
                <div style={{ textAlign: 'center', width: '100%' }}>
                    {row.Patients_Count ? row.Patients_Count : 'NA'}
                    {row.completed_patient_count > 0 && (
                        <span style={{
                            marginLeft: '5px'
                        }}>
                            / {row.completed_patient_count}
                        </span>
                    )}
                </div>
            ),
        },
        {
            name: (
                <div style={{ textAlign: 'center', width: '100%' }}> Execution<br /> Duration</div>
            ),
            cell: (row: any) => (
                <div style={{ textAlign: 'center', width: '100%' }}>
                    {row.total_execution_time !== '' ? row.total_execution_time : 'NA'}
                </div>
            ),
            sortable: true,
            filter: true,
            width: "180px",
            filterType: 'text',
        },
        {
            name: 'Patient List',
            cell: (row: any) => (
                <Badge
                    style={{ cursor: 'pointer', }}
                    color="primary"
                    size="sm"
                    onClick={() => {
                        navigate(`/bulkupload/patient/${row.id}`);
                    }}
                >
                    <h5>View Patients</h5>
                </Badge>
            ),
        },
        {
            name: 'Actions',
            width: "250px",
            cell: (row: DeleteRowData) => {
                return (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "0px"
                    }}>
                        {/* Download ZIP */}
                        <div style={{ width: 40, textAlign: "center" }}>
                            {row.template_creation === "C" && (
                                <>
                                    <div
                                        onClick={() => {
                                            getallpatientdetails_Zipfile(row);
                                            handleDownloadstatus(row);
                                        }}
                                        style={{ display: 'inline-block' }}
                                        id={`positionzipfile-${row.id}`}
                                    >
                                        {isDownloading === row.id ? (
                                            <div className="spinner"></div>
                                        ) : (
                                            <Download style={{ cursor: 'pointer' }} />
                                        )}
                                    </div>
                                    <UncontrolledTooltip
                                        placement="top"
                                        target={`positionzipfile-${row.id}`}
                                        style={{ backgroundColor: "#355876", color: "white" }}
                                    >
                                        All Patient Output
                                    </UncontrolledTooltip>
                                </>
                            )}
                        </div>
                        {/* Error */}
                        <div style={{ width: 40, textAlign: "center" }}>
                            {row.Data_Fetched === "E" && (
                                <div style={{ color: 'red', fontSize: '12px' }}>Error</div>
                            )}
                        </div>
                        {/* PDF Download */}
                        <div style={{ width: 40, textAlign: "center" }}>
                            {row.pdf_status === "yes" && (
                                <>
                                    <img
                                        src={portaldownload}
                                        alt="Download PDF"
                                        width={30}
                                        height={30}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handlePortalsPDFDocument(row.id, row)}
                                        id={`positionportalpdf-${row.id}`}
                                    />
                                    <UncontrolledTooltip
                                        placement="top"
                                        target={`positionportalpdf-${row.id}`}
                                        style={{ backgroundColor: "#355876", color: "white" }}
                                    >
                                        Portal Pdf
                                    </UncontrolledTooltip>
                                </>
                            )}
                        </div>
                        {/* Audit Log */}
                        <div style={{ width: 40, textAlign: "center" }}>
                            <Eye
                                size={17}
                                id={`positionLeft-${row.id}`}
                                color='#09d5ff'
                                onClick={() => {
                                    setScrollInnerModal(true)
                                    setRefid(row.id)
                                }}
                                style={{ cursor: 'pointer' }}
                            />
                            <UncontrolledTooltip
                                placement="top"
                                target={`positionLeft-${row.id}`}
                                style={{ backgroundColor: "#355876", color: "white" }}
                            >
                                Audit log
                            </UncontrolledTooltip>
                        </div>
                        {/* Restart Data Fetch */}
                        <div style={{ width: 40, textAlign: "center" }}>
                            {row.Data_Fetched === "E" && menuActions.includes("restart") && (
                                <>
                                    <RefreshCw
                                        size={17}
                                        id={`positionRestart-${row.id}`}
                                        color='#28a745'
                                        onClick={() => handleRestartDataFetch(row)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <UncontrolledTooltip
                                        placement="top"
                                        target={`positionRestart-${row.id}`}
                                        style={{ backgroundColor: "#355876", color: "white" }}
                                    >
                                        Restart
                                    </UncontrolledTooltip>
                                </>
                            )}
                        </div>


                    </div>
                );
            },
        },
    ]

    const customStyles = {
        rows: {
            style: {
                '&:hover': {
                    backgroundColor: '#f0f0f0',

                },
            },
        },
        headCells: {
            style: {
                backgroundColor: '#355876',  // Change background color of headers
                color: 'white',  // Change text color of headers
                fontSize: '16px',  // Adjust font size of headers
            },
        },
    };

    const GetMappedPatient = async () => {
        try {
            // const response = await axios.post(`${webservice}api/getMappedPatients`);

            const response = await api.fetch('api/getMappedPatients', { method: 'POST' }).then(response => response.json());

            const data = response.data;
            // Do something with the data
            if (data.message === "Data successfully Mapped") {
                Swal.fire({
                    // title: 'Insurance Verification Platform',
                    html: '<span style="color: green;">Patient Mapped successfully!</span>',
                    icon: 'success',
                    customClass: {},
                    showClass: {
                        popup: 'animate__animated animate__flipInX',
                    },
                })
            }
        } catch (error) {
            console.error('Error fetching mapped patients:', error);
        }
    };

    const startIndex = (currentPage - 1) * rowsPerPage + 1;
    const endIndex = Math.min(currentPage * rowsPerPage, store.total);

    const CustomLoadingComponent = () => {
        return (
            <div className="">
                {store.no_Data === 'There is no Record Found' ? (
                    <h4>
                        <br />
                        <p>There are no records to display</p>
                    </h4>
                ) : (
                    <div className="custom-loader">
                        <label className="custom-label">Please wait...</label>
                        <div className="custom-loading"></div>
                    </div>
                )}
            </div>
        );
    };

    // ------------------bulk entry-----------------------------------------------------
    interface Patient {
        firstName: string;
        lastName: string;
        dob: string;
        memberId: string;
        insurance: string;
        Provider_or_Company_name: string;
        providerNpi: string;
        providerTaxid: string;
        city: string;
        state: string;
        postalCode: string;
        facility: string;
        type: string;
        // location: string;
        feeSchedule: string;
        InsuranceNetwork: string;
        dobError?: string;
        subscriberFirstName?: string;
        subscriberLastName?: string;
        subscriberDob?: string;
        subscriberDobError?: string;
        subscriberMemberId?: string;
        insuranceInvalid?: string;
        typeInvalid?: string;
        feeScheduleInvalid?: string;
        bot_status: string;
        SoftwareName?: boolean;
        Software_Vendor?: string;
    }
    // SoftwareName is boolean while every other Patient field is a string; excluding it keeps
    // the generic `updatedPatients[index][field] = value` writes below type-checkable.
    type PatientEditableField = Exclude<keyof Patient, 'SoftwareName'>;
    const [insuranceOptions, setInsurance] = useState<{ value: string; label: string; bot_status: string; SoftwareName: boolean; Software_Vendor: string; IsAPIEnabled: boolean }[]>([]);
    const [rpaTasks, setRpaTasks] = useState<BotManagerTask[]>([]);
    const [dynamicHeaders, setDynamicHeaders] = useState<DynamicInputHeader[]>([]);
    const [dynamicRows, setDynamicRows] = useState<Array<Record<string, any>>>([]);

    useEffect(() => {
        if (!selectedClientId) return;
        const get_Insurance = async () => {
            const key = await keyPromise
            const EncParams = await AesEncrypt(key, selectedClientId);
            const response = await api.fetch('api/Insurancename', {
                method: 'POST',
                body: JSON.stringify({ EncParams }),
            });

            const data = await response.json();
            const TempData = AesDecrypt(key, data);
            return TempData;
        };

        const fetchinsurance = async () => {
            const response = await get_Insurance();

            const res = response.map((data: any) => ({
                label: data.name,
                value: data.name,
                bot_status: data.bot_status || "",
                SoftwareName: data.SoftwareName || false,
                Software_Vendor: data.Software_Vendor || "",
                IsAPIEnabled: data.IsAPIEnabled || false
            }));
            setInsurance(res);
        };

        fetchinsurance();

        const socket = new WebSocket(`${websocket_webservice}ws/InsuranceDropdown/`);
        socket.onmessage = () => {
            fetchinsurance();
        };

        // Clean up the WebSocket connection when the component unmounts
        return () => {
            if (socket.readyState === 1) { // <-- This is important
                socket.close();
            }
        }
    }, [selectedClientId]);

    interface IOption {
        value: string;
        label: string;
    }
    const typeOptions: IOption[] = [
        { value: 'subscriber', label: 'Self' },
        { value: 'dependent', label: 'Dependent' },
    ];

    const feeScheduleOptions: IOption[] = [
        { value: 'PPO', label: 'PPO' },
        { value: 'PREMIER', label: 'PREMIER' },
        { value: 'NONPARTICIPATING', label: 'NONPARTICIPATING' },
    ];

    const emptyPatient = (): Patient => ({
        firstName: "",
        lastName: "",
        dob: "",
        memberId: "",
        insurance: "",
        Provider_or_Company_name: "",
        providerNpi: "",
        providerTaxid: "",
        city: "",
        state: "",
        postalCode: "",
        facility: "",
        type: "",
        feeSchedule: "",
        InsuranceNetwork: "",
        subscriberFirstName: "",
        subscriberLastName: "",
        subscriberDob: "",
        subscriberMemberId: "",
        bot_status: "",
        SoftwareName: false,
        Software_Vendor: ""
    });
    const [modal, setModal] = useState<boolean>(false);
    const [patients, setPatients] = useState<Patient[]>([emptyPatient()]);
    const [selectedColumn, setSelectedColumn] = useState<keyof Patient | null>(null);
    const selectedInsuranceName = useMemo(() => {
        const selectedInsurance = selectedUploadInsurance || patients[0]?.insurance || '';
        if (!selectedInsurance) return '';
        return insuranceOptions.find((option) => option.value === selectedInsurance)?.label || selectedInsurance;
    }, [selectedUploadInsurance, patients, insuranceOptions]);
    const matchedRpaTask = useMemo(() => {
        if (!selectedInsuranceName) return null;
        return rpaTasks.find((task) => task.project_title?.trim().toLowerCase() === selectedInsuranceName.trim().toLowerCase()) || null;
    }, [rpaTasks, selectedInsuranceName]);
    const isDynamicRpaMode = dynamicHeaders.length > 0 && !!matchedRpaTask;

    useEffect(() => {
        if (!modal || !matchedRpaTask) {
            setDynamicHeaders([]);
            setDynamicRows([]);
            return;
        }

        const headers = extractDynamicHeaders(matchedRpaTask.steps, matchedRpaTask.multiple);
        setDynamicHeaders(headers);
        setDynamicRows(normalizeDynamicRows(headers));
    }, [modal, matchedRpaTask]);

    const toggleModal = (): void => {
        setModal(!modal);
        setPatients([emptyPatient()]);// Ensure emptyPatient() is called properly
        setSelectedClient('');
        setSelectedClientId('');
        setSelectedAddress('');
        setSelectedAddressId('');
        setselectedtemplate('');
        setselectedtemplateId('');
        setSelectedUploadInsurance('');
        setAddress([]);
        setSelectedBotstatus('');
        setSelectedSoftwareName(false);
        setSelectedSoftwareVendor('');
        setDynamicHeaders([]);
        setDynamicRows([]);
    };
    const handleChange = (index: number, field: PatientEditableField, value: string): void => {
        const updatedPatients = [...patients];
        updatedPatients[index][field] = value;

        // Selecting a value from the Fee Schedule dropdown clears the earlier invalid-import warning
        if (field === "feeSchedule") {
            updatedPatients[index].feeScheduleInvalid = "";
        }

        // If the changed field is 'insurance', also update the bot_status/SoftwareName/Software_Vendor from the matching option
        if (field === "insurance") {
            const selectedOption = insuranceOptions.find(opt => opt.value === value);
            const botStatus = selectedOption?.bot_status || "";
            const softwareName = selectedOption?.SoftwareName || false;
            const softwareVendor = selectedOption?.Software_Vendor || "";
            updatedPatients[index].bot_status = botStatus;
            updatedPatients[index].SoftwareName = softwareName;
            updatedPatients[index].Software_Vendor = softwareVendor;
            setSelectedBotstatus(botStatus);
            setSelectedSoftwareName(softwareName);
            setSelectedSoftwareVendor(softwareVendor);
        }

        setPatients(updatedPatients);
    };

    const handleDynamicPaste = (event: React.ClipboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        event.preventDefault();
        const data = event.clipboardData.getData('text');
        if (!data || dynamicHeaders.length === 0) return;

        const rows = data.split(/\r?\n/).filter((line) => line.trim() !== '');
        const newRows = rows.map((line) => {
            const values = line.split('\t');
            const row: Record<string, any> = {};
            dynamicHeaders.forEach((header, index) => {
                row[header.key] = values[index] || '';
            });
            return row;
        });

        setDynamicRows((previous) => {
            const isInitialEmptyRow = previous.length === 1 && dynamicHeaders.every((header) => !previous[0]?.[header.key]);
            return isInitialEmptyRow ? newRows : [...previous, ...newRows];
        });
    };

    const handleDynamicChange = (rowIndex: number, key: string, value: string) => {
        setDynamicRows((previous) => previous.map((row, index) => index === rowIndex ? { ...row, [key]: value } : row));
    };

    const handleDynamicAddRow = () => {
        setDynamicRows((previous) => [...previous, createEmptyDynamicRow(dynamicHeaders)]);
    };

    const handleDynamicRemoveRow = (rowIndex: number) => {
        setDynamicRows((previous) => previous.length === 1 ? [createEmptyDynamicRow(dynamicHeaders)] : previous.filter((_, index) => index !== rowIndex));
    };

    const addRows = (count: number): void => {
        setPatients([...patients, ...Array.from({ length: count }, emptyPatient)]);
    };

    const removeRow = (index: number): void => {
        if (patients.length > 1) {
            setPatients(patients.filter((_, i) => i !== index));
        }
        if (patients.length === 1) {
            setPatients([emptyPatient()]); // Ensure at least one empty row remains
        }
    };

    const handlePaste = (event: React.ClipboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        event.preventDefault();

        const clipboardData = event.clipboardData.getData("text");
        let rows = clipboardData.split("\n").map(row => row.split("\t"));


        // Remove empty rows
        rows = rows.filter(row => row.some(cell => cell.trim() !== ""));

        if (rows.length === 0) return;

        // Create new patients from pasted rows
        const newPatients = rows.map((row) => {
            const validType = typeOptions.find(opt => opt.label.toLowerCase() === row[11]?.toLowerCase().trim());
            const validFeeSchedule = feeScheduleOptions.find(opt => opt.label.toLowerCase() === row[17]?.toLowerCase().trim());

            return {
                insurance: selectedUploadInsurance || "",
                firstName: row[0] || "",
                lastName: row[1] || "",
                dob: row[2] ? moment(row[2], ["MM/DD/YYYY", "YYYY/MM/DD", "DD/MM/YYYY"]).format("MM/DD/YYYY") : "",
                memberId: row[3] || "",
                Provider_or_Company_name: row[4] || "",
                providerNpi: row[5] || "",
                providerTaxid: row[6] || "",
                city: row[7] || "",
                state: row[8] || "",
                postalCode: row[9] || "",
                facility: row[10] || "",
                type: validType ? validType.value : row[11] || "",
                subscriberFirstName: row[12] || "",
                subscriberLastName: row[13] || "",
                subscriberDob: row[14] ? moment(row[14], ["MM/DD/YYYY", "YYYY/MM/DD", "DD/MM/YYYY"]).format("MM/DD/YYYY") : "",
                subscriberMemberId: row[15] || "",
                InsuranceNetwork: row[16] || "",
                feeSchedule: validFeeSchedule ? validFeeSchedule.value : row[17] || "",
                typeInvalid: !validType && row[11] ? row[11] : "",
                feeScheduleInvalid: !validFeeSchedule && row[17] ? row[17] : "",
                bot_status: SelectedBotstatus || "",
                SoftwareName: SelectedSoftwareName || false,
                Software_Vendor: SelectedSoftwareVendor || "",
            };
        });

        // Move empty rows to the end and keep exactly one empty row at the bottom for data entry
        const nonEmptyRows = newPatients.filter((p) => {
            return p.firstName || p.lastName || p.dob || p.memberId || p.Provider_or_Company_name ||
                p.providerNpi || p.providerTaxid || p.city || p.state || p.postalCode ||
                p.facility || p.type || p.subscriberFirstName || p.subscriberLastName ||
                p.subscriberDob || p.subscriberMemberId || p.InsuranceNetwork || p.feeSchedule;
        });

        // Keep non-empty rows plus one empty row at the end
        const finalPatients = nonEmptyRows.length > 0 ? [...nonEmptyRows, emptyPatient()] : [emptyPatient()];

        setPatients(finalPatients);
    };


    const handleColumnPaste = (
        event: React.ClipboardEvent<HTMLDivElement>,
        field: PatientEditableField,
        startIndex: number
    ) => {
        event.preventDefault();
        const clipboardData = event.clipboardData.getData("text");
        const values = clipboardData.split("\n").map(val => val.trim()).filter(val => val !== "");

        if (values.length === 0) return;

        const updatedPatients = [...patients];

        // Define acceptable date formats
        const dateFormats = ["MM/DD/YYYY", "YYYY-MM-DD", "DD/MM/YYYY", "MM-DD-YYYY", "M-D-YYYY"];

        values.forEach((value, i) => {
            const rowIndex = startIndex + i;
            // Only paste into existing rows, don't create new ones
            if (rowIndex < updatedPatients.length) {
                if (field === "dob") {
                    // Parse the input date using Moment.js in strict mode
                    const parsedDate = moment(value, dateFormats, true);
                    updatedPatients[rowIndex][field] = parsedDate.isValid() ? parsedDate.format("MM/DD/YYYY") : "";
                } else if (field === "subscriberDob") {
                    // Parse the input date using Moment.js in strict mode
                    const parsedDate = moment(value, dateFormats, true);
                    updatedPatients[rowIndex][field] = parsedDate.isValid() ? parsedDate.format("MM/DD/YYYY") : "";
                } else if (field === "type") {
                    const validType = typeOptions.find(opt => opt.label.toLowerCase() === value.toLowerCase());
                    updatedPatients[rowIndex][field] = validType ? validType.value : value;
                } else if (field === "insurance") {
                    const validInsurance = insuranceOptions.find(opt => opt.label.toLowerCase() === value.toLowerCase());
                    updatedPatients[rowIndex][field] = validInsurance ? validInsurance.value : value;
                    if (validInsurance) {
                        updatedPatients[rowIndex].bot_status = validInsurance.bot_status || "";
                        updatedPatients[rowIndex].SoftwareName = validInsurance.SoftwareName || false;
                        updatedPatients[rowIndex].Software_Vendor = validInsurance.Software_Vendor || "";
                        setSelectedBotstatus(validInsurance.bot_status || "");
                        setSelectedSoftwareName(validInsurance.SoftwareName || false);
                        setSelectedSoftwareVendor(validInsurance.Software_Vendor || "");
                    }
                } else {
                    updatedPatients[rowIndex][field] = value;
                }
            }
            // Removed: else block that created new rows
        });

        setPatients(updatedPatients);
    };

    // Parse & validate patient DOB (returns formatted date or error message)
    const parseAndValidateDob = (input: string) => {
        const dateFormats = ["MM/DD/YYYY", "YYYY-MM-DD", "DD/MM/YYYY", "MM-DD-YYYY", "M-D-YYYY", "M/D/YYYY"];
        const parsed = moment(input, dateFormats, true);
        if (!parsed.isValid()) {
            return { formatted: "", error: "Invalid date format. Use MM/DD/YYYY." };
        }
        if (parsed.isAfter(moment(), "day")) {
            return { formatted: "", error: "Date of birth cannot be in the future." };
        }
        return { formatted: parsed.format("MM/DD/YYYY"), error: "" };
    };

    const handlebulkentrysave = async () => {
        if (!isDynamicRpaMode && patients.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Insurance Verification Platform',
                text: 'Please enter at least one patient’s details!',
            });
            return;
        }
        if (isDynamicRpaMode && dynamicRows.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Insurance Verification Platform',
                text: 'Please enter at least one row of insurance data!',
            });
            return;
        }
        if (!selectedClient) {
            Swal.fire({
                icon: 'warning',
                title: 'Insurance Verification Platform',
                text: 'Please Select Client!',
            });
            return;
        }
        if (!selectedtemplate) {
            Swal.fire({
                icon: 'warning',
                title: 'Insurance Verification Platform',
                text: 'Please Select Template!',
            });
            return;
        }
        if (!selectedUploadInsurance) {
            Swal.fire({
                icon: 'warning',
                title: 'Insurance Verification Platform',
                text: 'Please Select Insurance Name!',
            });
            return;
        }
        // if (!SelectedAddressname) {
        //     Swal.fire({
        //         icon: 'warning',
        //         title: 'Insurance Verification Platform',
        //         text: 'Please Select Address!',
        //     });
        //     return;
        // }

        // Remove patients where all fields are empty, and specifically exclude the last row if it's empty
        const nonEmptyPatients = patients.filter((p, index) => {
            // Always exclude the last row if it's empty
            if (index === patients.length - 1) {
                const lastRowEmpty =
                    !p.firstName?.trim() &&
                    !p.lastName?.trim() &&
                    !p.dob?.trim() &&
                    !p.memberId?.trim() &&
                    !p.providerNpi?.trim() &&
                    !p.Provider_or_Company_name?.trim() &&
                    !p.providerTaxid?.trim() &&
                    !p.city?.trim() &&
                    !p.state?.trim() &&
                    !p.postalCode?.trim() &&
                    !p.facility?.trim() &&
                    !p.type?.trim() &&
                    !p.subscriberFirstName?.trim() &&
                    !p.subscriberLastName?.trim() &&
                    !p.subscriberDob?.trim() &&
                    !p.subscriberMemberId?.trim() &&
                    !p.InsuranceNetwork?.trim() &&
                    !p.feeSchedule?.trim()
                if (lastRowEmpty) {
                    // console.log(`Last row ${index + 1} is empty and will be excluded`, p);
                    return false;
                }
            }

            const allEmpty =
                !p.firstName?.trim() &&
                !p.lastName?.trim() &&
                !p.dob?.trim() &&
                !p.memberId?.trim() &&
                !p.providerNpi?.trim() &&
                !p.Provider_or_Company_name?.trim() &&
                !p.providerTaxid?.trim() &&
                !p.city?.trim() &&
                !p.state?.trim() &&
                !p.postalCode?.trim() &&
                !p.facility?.trim() &&
                !p.type?.trim() &&
                !p.subscriberFirstName?.trim() &&
                !p.subscriberLastName?.trim() &&
                !p.subscriberDob?.trim() &&
                !p.subscriberMemberId?.trim() &&
                !p.InsuranceNetwork?.trim() &&
                !p.feeSchedule?.trim()

            if (allEmpty) {
                // console.log(`Row ${index + 1} is completely empty and will be removed`, p);
            }
            return !allEmpty;
        });

        const nonEmptyDynamicRows = dynamicRows.filter((row) =>
            dynamicHeaders.some((header) => `${row[header.key] || ''}`.trim() !== '')
        );

        // Update patients state
        if (!isDynamicRpaMode && nonEmptyPatients.length < patients.length) {
            setPatients(nonEmptyPatients);
        }
        if (isDynamicRpaMode && nonEmptyDynamicRows.length < dynamicRows.length) {
            setDynamicRows(nonEmptyDynamicRows);
        }

        setLoading(true)
        const userid = localStorage.id
        const vendorid = (localStorage.UserType === 'Vendor') ? localStorage.VendorId : "";
        const auditMemberIdLogs: { field: string; before: string; after: string }[] = [];

        const bulkPayload = (isDynamicRpaMode ? nonEmptyDynamicRows : nonEmptyPatients).map((patient: any) => {
            // Clean and log for each field
            const cleanAndLog = (fieldLabel: string, value: string | undefined) => {
                const before = value || "";
                const after = before.replace(/^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$/g, "");
                if (before !== after) {
                    auditMemberIdLogs.push({ field: fieldLabel, before, after });
                }
                return after;
            };

            if (isDynamicRpaMode) {
                const dynamicData: Record<string, string> = {};
                dynamicHeaders.forEach((header) => {
                    dynamicData[header.key] = `${patient[header.key] || ''}`;
                });

                return {
                    ClientName: selectedClient,
                    ClientId: selectedClientId,
                    template: selectedtemplate,
                    templateId: selectedtemplateId,
                    Address: SelectedAddressname,
                    Username: Username,
                    screenshot_status: Screenshot_status,
                    Payer_name: selectedUploadInsurance,
                    Uploaded_userid: userid,
                    Patients_Count: nonEmptyDynamicRows.length,
                    vendor_id: vendorid,
                    bot_status: SelectedBotstatus || '',
                    SoftwareName: SelectedSoftwareName || false,
                    Software_Vendor: SelectedSoftwareVendor || '',
                    rpa_bot_id: matchedRpaTask?.id || '',
                    dynamic_fields: dynamicHeaders.map((header) => ({ key: header.key, prompt: header.prompt })),
                    dynamic_data: dynamicData,
                };
            }

            return {
                ClientName: selectedClient,
                ClientId: selectedClientId,
                template: selectedtemplate,
                templateId: selectedtemplateId,
                Address: SelectedAddressname,
                Username: Username,
                screenshot_status: Screenshot_status,
                FirstName: patient.firstName || "",
                lastName: patient.lastName || "",
                DoB: patient.dob || "",
                Memberid: cleanAndLog("Member Id", patient.memberId),
                Payer_name: selectedUploadInsurance || patient.insurance || "",
                ProviderNPI: cleanAndLog("Provider NPI", patient.providerNpi),
                Type: cleanAndLog("Patient Type", patient.type),
                Fee_Schedule: patient.feeSchedule || "",
                Provider_or_Company_name: cleanAndLog("Provider or Company name", patient.Provider_or_Company_name),
                providerTaxid: cleanAndLog("Provider Tax Id", patient.providerTaxid),
                subscriberFirstName: cleanAndLog("subscriberFirstName", patient.subscriberFirstName),
                subscriberLastName: cleanAndLog("subscriberLastName", patient.subscriberLastName),
                subscriberDob: cleanAndLog("subscriberDob", patient.subscriberDob),
                subscriberMemberId: cleanAndLog("subscriberMemberId", patient.subscriberMemberId),
                city: cleanAndLog("city", patient.city),
                state: cleanAndLog("state", patient.state),
                postalCode: cleanAndLog("postalCode", patient.postalCode),
                facility: cleanAndLog("facility", patient.facility),
                InsuranceNetwork: cleanAndLog("Insurance Network", patient.InsuranceNetwork),
                Uploaded_userid: userid,
                Patients_Count: nonEmptyPatients.length,
                vendor_id: vendorid,
                bot_status: SelectedBotstatus || patient.bot_status || "",
                SoftwareName: SelectedSoftwareName || patient.SoftwareName || false,
                Software_Vendor: SelectedSoftwareVendor || patient.Software_Vendor || ""
            };
        });
        // console.log(bulkPayload);
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, bulkPayload);
        const response = await api.fetch('api/bulkupload/addBulkPatientdetails', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then(response => response.json());
        if (response.message === "Bulk upload successful") {
            const patientIds = response.patient_ids || [];
            const batchInsuranceName = selectedUploadInsurance || (nonEmptyPatients.length > 0 ? nonEmptyPatients[0].insurance : "");
            localStorage.setItem('currentBatchPatientIds', JSON.stringify(patientIds));
            localStorage.setItem('currentBatchInsuranceName', batchInsuranceName);

            const editauditData = { auditLogData: auditMemberIdLogs, Username };

            if (auditMemberIdLogs.length !== 0) {
                const auditData = editauditData;
                await api.fetch('api/BulkUpload/EditauditLogdata', {
                    method: 'POST',
                    body: JSON.stringify({ auditData })
                }).then((response) => response.json());
            }

            const noOtpInsurances = ['Blue Cross Blue Shield of Texas', 'UCCI', 'Central States', 'DNOA'];
            const batchBotStatus = SelectedBotstatus || (nonEmptyPatients.length > 0 ? nonEmptyPatients[0].bot_status : "");
            const isBatchApiEnabled = !!insuranceOptions.find((option) => option.value === batchInsuranceName)?.IsAPIEnabled;
            const isNoOtp = isBatchApiEnabled || noOtpInsurances.includes(batchInsuranceName) || batchBotStatus === 'B';

            if (!isNoOtp) {
                localStorage.setItem('isBulkUploadProcessing', 'true');
            }

            Swal.fire({
                html: `
                <div style="text-align: center;">
                    <span style="color: green; font-weight: bold; font-size: 1.2em;">Patients Added successfully!</span>
                    ${isNoOtp ? '' : `
                        <br/><br/><span>OTP Authentication in progress for <b>${batchInsuranceName}</b>, please wait...</span>
                        <br/><br/>
                        <div style="background-color: #fff3cd; color: #856404; padding: 10px; border-radius: 5px; border: 1px solid #ffeeba; margin-top: 10px;">
                            <strong>⚠️ Warning:</strong> Please do not refresh the page until the authentication process is complete.
                        </div>
                    `}
                </div>
            `,
                icon: 'success',
                allowOutsideClick: isNoOtp,
                allowEscapeKey: isNoOtp,
                showConfirmButton: isNoOtp,
                showClass: {
                    popup: 'animate__animated animate__flipInX',
                },
                didOpen: () => {
                    if (!isNoOtp) {
                        Swal.showLoading();
                    }
                }
            });
            //                 showClass: {
            //                     popup: 'animate__animated animate__flipInX',
            //                 },
            //             })

            // Trigger RPA automation if in dynamic RPA mode
            if (isDynamicRpaMode && matchedRpaTask) {
                try {
                    const key = await keyPromise;
                    const rpaPayload = {
                        rpa_bot_id: matchedRpaTask.id,
                        user_id: userid
                    };
                    const EncParams = await AesEncrypt(key, rpaPayload);
                    const rpaResponse = await api.fetch('api/bulkupload/triggerRpaBulkAutomation', {
                        method: 'POST',
                        body: JSON.stringify({ EncParams })
                    }).then(response => response.json());

                    if (rpaResponse.status === 'success') {
                        Swal.fire({
                            title: 'RPA Automation Triggered',
                            html: `<span style="color: blue;">RPA automation started for ${rpaResponse.patients_count} patients!</span>`,
                            icon: 'info',
                            timer: 3000,
                            showConfirmButton: false
                        });
                    } else {
                        console.error('RPA automation failed:', rpaResponse);
                        Swal.fire({
                            title: 'RPA Automation Failed',
                            html: `<span style="color: orange;">RPA automation could not be started: ${rpaResponse.message || 'Unknown error'}</span>`,
                            icon: 'warning',
                            timer: 3000,
                            showConfirmButton: false
                        });
                    }
                } catch (error) {
                    console.error('Error triggering RPA automation:', error);
                    Swal.fire({
                        title: 'RPA Automation Error',
                        html: '<span style="color: red;">Error connecting to RPA automation service</span>',
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false
                    });
                }
            }

            fetchDataWithParams({});
            setLoading(false);
            setModal(!modal);
            setPatients([emptyPatient()]);// Ensure emptyPatient() is called properly
            setSelectedClient('');
            setSelectedClientId('');
            setSelectedAddress('');
            setSelectedAddressId('');
            setselectedtemplate('');
            setselectedtemplateId('');
            setSelectedUploadInsurance('');
            setAddress([]);
            setSelectedBotstatus('');
            setSelectedSoftwareName(false);
            setSelectedSoftwareVendor('');

        }

    }

    // ------------------bulk entry-----------------------------------------------------

    const getAuditlogdata = async (data: any) => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, data);
        const response = await api.fetch('api/Bulk-upload/get-audit-log-data', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());
        const TempData = await AesDecrypt(key, response);

        return TempData;
    };

    useEffect(() => {
        const fetchData = async () => {
            if (refid !== null) {
                const res = await getAuditlogdata(refid);
                setFilteredAuditData(res);
            }
        };
        fetchData();
    }, [refid]);


    return (
        <Fragment>
            <Row>
                <Col xl={12}>
                    <CardBody>
                        <div className="table-responsive">
                            <div className="dataTables_wrapper">
                                <DataTable
                                    persistTableHead
                                    subHeader={true}
                                    responsive={true}
                                    onSort={handleSort}
                                    data={dataToRender()}
                                    columns={Columns}
                                    paginationServer
                                    customStyles={customStyles}
                                    paginationPerPage={rowsPerPage}
                                    paginationDefaultPage={currentPage}
                                    selectableRows
                                    selectableRowsHighlight
                                    selectableRowsComponent={BootstrapCheckbox as unknown as React.ReactNode}
                                    onSelectedRowsChange={handleChangecheck}
                                    paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                                    noDataComponent={<CustomLoadingComponent />}
                                    paginationComponent={CustomPagination}
                                    expandableRows
                                    expandableRowsComponent={ExpandedComponent}
                                    subHeaderComponent={
                                        <CustomHeader
                                            value={value}
                                            rowsPerPage={rowsPerPage}
                                            handleFilter={handleFilter}
                                            handlePerPage={handlePerPage}
                                            toggleModal={toggleModal}
                                            handleClientFilter={handleClientFilter}
                                            setSelectedClientOption={setSelectedClientOption}
                                            selectedClientOption={selectedClientOption}
                                            clientOptions={clientOptions}
                                            clientList={userClient}
                                            handleuserclientChange={handleuserclientChange}
                                            insuranceList={filterInsuranceOptions}
                                            handleInsuranceChange={handleInsuranceChange}
                                            handleExpandAll={handleExpandAll}
                                            isAllExpanded={isAllExpanded}
                                            showFilters={showFilters}
                                            setShowFilters={setShowFilters}
                                        />
                                    }
                                    expandableRowExpanded={(row) => expandedRows.includes(row.id)}
                                    onRowExpandToggled={handleRowExpandToggled}
                                    expandableRowsHideExpander
                                />
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ paddingLeft: '2%' }}>
                                        {store.total && (
                                            <span><strong>{`${startIndex} to ${endIndex} of ${store.total} entries`}</strong></span>
                                        )}
                                    </div>
                                    <div>
                                        <CustomPagination />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Col>
            </Row>
            <div>
                {eventId1 > 0 && menuActions.includes('delete') && (
                    <div className="customizer-links open">
                        <Nav className=" flex-column nav-pills">
                            <a className="nav-link" onClick={() => DeleteUpload(eventId)}>
                                <span>Delete</span>
                                <Trash2 className="trash-icon" size={20} />
                            </a>
                        </Nav>
                    </div>
                )}
            </div>
            {Downloading && (
                <div >
                    <div className="loading-overlay">
                        <div id="page">
                            <div id="container">
                                <div id="ring"></div>
                                <div id="ring"></div>
                                <div id="ring"></div>
                                <div id="ring"></div>
                                <div id="h3" style={{ color: "black" }}>Downloading...</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <Modal isOpen={isCardModalOpen} toggle={toggleCardModalOpen}>
                <ModalHeader toggle={toggleCardModalOpen}><h3>Assign Patient</h3></ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label for="addFieldValue">Select Vendor :</Label>
                            <Select
                                isClearable
                                options={VendorOptions}
                                classNamePrefix="select"
                                placeholder="Select Template"
                                className={classnames("react-select", {
                                    "is-invalid": errors.ClientName && true,
                                })}
                            />
                        </FormGroup>
                        <br />
                        <Button color="secondary" style={{ float: "right" }} onClick={handleAssignVendor}>Submit</Button>
                    </Form>
                </ModalBody>
            </Modal>
            <Modal isOpen={modal} toggle={toggleModal} size="xl" style={{ maxWidth: "95%", }}>
                <ModalHeader
                    toggle={toggleModal}
                    style={{ backgroundColor: "#00213b", color: "white" }}
                    close={
                        <Button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={toggleModal}
                            color='danger'
                        >
                        </Button>
                    }
                >
                    Enter Patient Details
                </ModalHeader>
                <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    <p style={{ color: 'red', fontWeight: 'bold', marginBottom: '10px' }}>
                        Note: Only one insurance can be uploaded at a time.
                    </p>
                    <Row>
                        {localStorage.UserType === 'MOS' && (
                            <Col xl={3}>
                                <Label className="form-label" style={{ fontSize: "110%" }}>
                                    Select Client <span style={{ color: "red" }}> * </span>
                                </Label>
                                <Select
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    isClearable
                                    options={clientOptions}
                                    // value={clientOptions.find((e)=>e.label===selectedClient)}
                                    classNamePrefix="select"
                                    placeholder="Type Here"
                                    //   theme={selectThemeColors}  
                                    className={classnames("react-select", {
                                        "is-invalid": errors.ClientName && true,
                                    })}
                                    // {...field}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 99999 }),
 control: (styles) => ({
                                            ...styles,
                                            width: "100%",
                                            borderColor: "black",
                                        }),
                                        placeholder: (styles) => ({
                                            ...styles,
                                            textAlign: "center",
                                        }),
                                    }}
                                    value={selectedClient ? { value: selectedClientId, label: selectedClient } : ""}
                                    onChange={(selectedOption) => {
                                        // field.onChange(selectedOption);
                                        handleSelectClientChange(selectedOption as SingleValue<IClientOption>);
                                    }}
                                />
                                {errors.ClientName && (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                        {errors.ClientName.message}
                                    </span>
                                )}
                            </Col>
                        )}
                        {localStorage.UserType === 'Vendor' && (
                            <Col xl={3}>
                                <Label className="form-label" style={{ fontSize: "110%" }}>
                                    Select Client <span style={{ color: "red" }}> * </span>
                                </Label>
                                <Select
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    isClearable
                                    options={vendorbasedclientOptions}
                                    // value={clientOptions.find((e)=>e.label===selectedClient)}
                                    classNamePrefix="select"
                                    placeholder="Type Here"
                                    //   theme={selectThemeColors}  
                                    className={classnames("react-select", {
                                        "is-invalid": errors.ClientName && true,
                                    })}
                                    // {...field}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 99999 }),
 control: (styles) => ({
                                            ...styles,
                                            width: "100%",
                                            borderColor: "black",
                                        }),
                                        placeholder: (styles) => ({
                                            ...styles,
                                            textAlign: "center",
                                        }),
                                    }}
                                    value={selectedClient ? { value: selectedClientId, label: selectedClient } : ""}
                                    onChange={(selectedOption) => {
                                        // field.onChange(selectedOption);
                                        handleSelectClientChange(selectedOption as SingleValue<IClientOption>);
                                    }}
                                />
                                {errors.ClientName && (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                        {errors.ClientName.message}
                                    </span>
                                )}
                            </Col>
                        )}


                        <Col xl={3}>
                            <Label className="form-label" style={{ fontSize: "110%" }}>
                                Select Template <span style={{ color: "red" }}> * </span>
                            </Label>
                            <Select
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                isClearable
                                options={templateOptions}
                                // value={clientOptions.find((e)=>e.label===selectedClient)}
                                classNamePrefix="select"
                                placeholder="Type Here"
                                //   theme={selectThemeColors}  
                                className={classnames("react-select", {
                                    "is-invalid": errors.Address && true,
                                })}
                                // {...field}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 99999 }),
 control: (styles) => ({
                                        ...styles,
                                        width: "100%",
                                        borderColor: "black",
                                    }),
                                    placeholder: (styles) => ({
                                        ...styles,
                                        textAlign: "center",
                                    }),
                                }}
                                value={selectedtemplate ? { value: selectedtemplateId, label: selectedtemplate } : ""}
                                onChange={(selectedOption) => {
                                    // field.onChange(selectedOption);
                                    handleSelecttemplateChange(selectedOption as SingleValue<IClientOption>);
                                }}
                            />
                            {errors.ClientName && (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                    {errors.ClientName.message}
                                </span>
                            )}
                        </Col>
                        <Col xl={3}>
                            <Label className="form-label" style={{ fontSize: "110%" }}>
                                Insurance Name <span style={{ color: "red" }}> * </span>
                            </Label>
                            <Select
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                isClearable
                                options={insuranceOptions}
                                classNamePrefix="select"
                                placeholder="Select Insurance"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 99999 }),
 control: (styles) => ({
                                        ...styles,
                                        width: "100%",
                                        borderColor: "black",
                                    }),
                                    placeholder: (styles) => ({
                                        ...styles,
                                        textAlign: "center",
                                    }),
                                }}
                                value={selectedUploadInsurance ? { value: selectedUploadInsurance, label: selectedInsuranceName } : ""}
                                onChange={(selectedOption) => handleUploadInsuranceChange(selectedOption as SingleValue<IClientOption>)}
                            />
                        </Col>
                        <Col md={3} xs={12} >
                            <div className="d-flex" style={{ marginTop: "5%" }}  >
                                <Label
                                    className="form-label me-2"
                                    for="Screenshot_status"
                                    style={{ fontSize: "120%", color: "#000" }}
                                >
                                    Screenshot Status:
                                </Label>
                                <div className="form-check form-check-inline" style={{ display: "flex", alignItems: "center", justifyContent: "center", }}>
                                    <input
                                        type="radio"
                                        name="Screenshot_status"
                                        id="Screenshot_statusYes"
                                        value="Yes"
                                        onChange={handleScreenshot_statusChange}
                                        className="radio-button"
                                        style={{ width: "15px", height: "15px", margin: "0 0" }}
                                    />
                                    &nbsp;&nbsp;
                                    <div>
                                        <Label className="form-check-label" htmlFor="Screenshot_statusYes" style={{ marginBottom: "0px" }}>
                                            YES
                                        </Label>
                                    </div>
                                </div>
                                <div className="form-check form-check-inline" style={{ display: "flex", alignItems: "center", justifyContent: "center", }}>
                                    <input
                                        type="radio"
                                        name="Screenshot_status"
                                        id="Screenshot_statusNo"
                                        value="No"
                                        onChange={handleScreenshot_statusChange}
                                        style={{ width: "15px", height: "15px", margin: "0 0" }}
                                        defaultChecked
                                        className="radio-button" // Apply class for custom styling
                                    />
                                    &nbsp;&nbsp;
                                    <div>
                                        <Label className="form-check-label" htmlFor="Screenshot_statusNo" style={{ marginBottom: "0px" }}>
                                            NO
                                        </Label>
                                    </div>


                                </div>
                            </div>
                        </Col>

                    </Row>
                    <div className="mt-3">
                        <label>Paste from Excel:</label>
                        <Input
                            type="textarea"
                            style={{ height: "90px", resize: "none" }}
                            onPaste={(event: React.ClipboardEvent<HTMLInputElement>) => isDynamicRpaMode ? handleDynamicPaste(event) : handlePaste(event)}
                            placeholder={isDynamicRpaMode
                                ? `Paste multiple rows from Excel here...\n${dynamicHeaders.map((header) => header.key).join(' | ')}`
                                : `📋 Paste multiple rows from Excel here...
                            🔹 First Name🔹 Last Name🔹 Patient DOB🔹 Member ID🔹 Provider or Company Name🔹 Provider NPI🔹 Provider Tax ID🔹 City🔹 State🔹 Zip Code🔹 Facility🔹 Patient Type🔹Subscriber First Name🔹Subscriber Last Name🔹Subscriber Patient DOB🔹Subscriber Member ID🔹 Insurance Network🔹 Fee Schedule
                           ⚠️ Important: Please ensure that the columns are arranged in the exact order specified above.`}
                        />
                    </div>
                    {loading && (
                        <div className="loading-overlay-bulk">
                            <div id="container-bulk">
                                <div id="ring"></div>
                                <div id="ring"></div>
                                <div id="ring"></div>
                                <div id="ring"></div>
                                <div id="h3" style={{ color: "#00213b", fontWeight: "bold" }}>Uploading...</div>
                            </div>
                        </div>
                    )}

                    &nbsp;&nbsp;&nbsp;
                    <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: "420px", border: "1px solid #c9d8e4", borderRadius: "6px" }}>
                        {isDynamicRpaMode ? (
                            <Table bordered className="text-center" style={{ marginBottom: 0 }}>
                                <thead style={{ position: "sticky", top: 0, zIndex: 2, backgroundColor: "#c9d8e4" }}>
                                    <tr style={{ backgroundColor: "#c9d8e4" }}>
                                        {dynamicHeaders.map((header) => (
                                            <th key={header.key} style={{ minWidth: "220px", position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>
                                                <div>{header.key.replace(/_/g, ' ')}</div>
                                                <div style={{ fontSize: "12px", color: "#2563eb", fontWeight: 400 }}>{header.prompt}</div>
                                            </th>
                                        ))}
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dynamicRows.map((row, rowIndex) => (
                                        <tr key={rowIndex}>
                                            {dynamicHeaders.map((header) => (
                                                // <td key={`${rowIndex}-${header.key}`} title={row[header.key] || ''}>
                                                //     <Input
                                                //         type="text"
                                                //         value={row[header.key] || ''}
                                                //         onChange={(e) => handleDynamicChange(rowIndex, header.key, e.target.value)}
                                                //     />
                                                // </td>
                                                <td key={`${rowIndex}-${header.key}`} title={row[header.key] || ''}>
                                                    {header.key === 'patient_type' ? (
                                                        <Select
                                                            isClearable
                                                            options={[
                                                                { value: 'self', label: 'Self' },
                                                                { value: 'dependent', label: 'Dependent' }
                                                            ]}
                                                            value={[
                                                                { value: 'self', label: 'Self' },
                                                                { value: 'dependent', label: 'Dependent' }
                                                            ].find(option => option.value === row[header.key])}
                                                            onChange={(selectedOption) => handleDynamicChange(rowIndex, header.key, selectedOption?.value || '')}
                                                            isSearchable
                                                            placeholder="Select Type"
                                                            styles={{ control: (base) => ({ ...base, minHeight: "38px", fontSize: "14px" }) }}
                                                        />
                                                    ) : header.key === 'fee_schedule' ? (
                                                        <Select
                                                            isClearable
                                                            options={[
                                                                { value: 'PPO', label: 'PPO' },
                                                                { value: 'PREMIER', label: 'PREMIER' },
                                                                { value: 'NONPARTICIPATING', label: 'NONPARTICIPATING' }
                                                            ]}
                                                            value={[
                                                                { value: 'PPO', label: 'PPO' },
                                                                { value: 'PREMIER', label: 'PREMIER' },
                                                                { value: 'NONPARTICIPATING', label: 'NONPARTICIPATING' }
                                                            ].find(option => option.value === row[header.key])}
                                                            onChange={(selectedOption) => handleDynamicChange(rowIndex, header.key, selectedOption?.value || '')}
                                                            isSearchable
                                                            placeholder="Fee Schedule"
                                                            styles={{ control: (base) => ({ ...base, minHeight: "38px", fontSize: "14px" }) }}
                                                        />
                                                    ) : (
                                                        <Input
                                                            type="text"
                                                            value={row[header.key] || ''}
                                                            onChange={(e) => handleDynamicChange(rowIndex, header.key, e.target.value)}
                                                        />
                                                    )}
                                                </td>
                                            ))}
                                            <td style={{ maxWidth: "5px" }}>
                                                <i
                                                    className="fa fa-times-circle-o cursor-pointer"
                                                    title="Clear"
                                                    onClick={() => handleDynamicRemoveRow(rowIndex)}
                                                    style={{ fontSize: '25px', color: 'red', cursor: 'pointer' }}
                                                ></i>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        ) : (
                            <Table bordered className="text-center" style={{ marginBottom: 0 }}>
                                <thead style={{ position: "sticky", top: 0, zIndex: 2, backgroundColor: "#c9d8e4" }}>
                                    <tr style={{ backgroundColor: "#c9d8e4" }}>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>First Name</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Last Name</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Patient DOB</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Member ID</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Provider or Company name</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Provider / Group NPI</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Provider Tax Id</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>City</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>State</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Zip Code</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Facility</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Patient Type</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Subscriber First Name</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Subscriber Last Name</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Subscriber DOB</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Subscriber Member Id</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Insurance Network</th>
                                        {/* <th>Location</th> */}
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Fee Schedule</th>
                                        <th style={{ position: "sticky", top: 0, backgroundColor: "#c9d8e4", zIndex: 2 }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {patients.map((patient, index) => {
                                        return (
                                            <tr key={index}>
                                                <td title={patient.firstName || ""}>
                                                    <Input
                                                        type="text"
                                                        value={patient.firstName}
                                                        onChange={(e) => handleChange(index, "firstName", e.target.value)}
                                                        onFocus={() => setSelectedColumn("firstName")}
                                                        onPaste={(e) => handleColumnPaste(e, "firstName", index)}
                                                    />
                                                </td>
                                                <td title={patient.lastName || ""}>
                                                    <Input
                                                        type="text"
                                                        value={patient.lastName}
                                                        onChange={(e) => handleChange(index, "lastName", e.target.value)}
                                                        onFocus={() => setSelectedColumn("lastName")}
                                                        onPaste={(e) => handleColumnPaste(e, "lastName", index)}
                                                    />
                                                </td>
                                                <td title={patient.dob || ""}>
                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        <Input
                                                            mask="99/99/9999"
                                                            type="text"
                                                            value={patient.dob}
                                                            placeholder="MM/DD/YYYY"
                                                            onChange={(e) => {
                                                                const newDob = e.target.value;
                                                                const updatedPatients = [...patients];
                                                                updatedPatients[index].dob = newDob;
                                                                updatedPatients[index].dobError = ""; // Clear error on type
                                                                setPatients(updatedPatients);
                                                            }}
                                                            onBlur={(e) => {
                                                                const inputDate = e.target.value;
                                                                const updatedPatients = [...patients];
                                                                const { formatted, error } = parseAndValidateDob(inputDate);
                                                                updatedPatients[index].dobError = error;
                                                                updatedPatients[index].dob = error ? "" : formatted;
                                                                setPatients(updatedPatients);
                                                            }}
                                                            onFocus={() => {
                                                                setSelectedColumn("dob");
                                                            }}
                                                            onPaste={(e) => {
                                                                e.preventDefault();
                                                                const pasted = e.clipboardData.getData("text");
                                                                const updatedPatients = [...patients];
                                                                const { formatted, error } = parseAndValidateDob(pasted);
                                                                updatedPatients[index].dobError = error;
                                                                if (!error) updatedPatients[index].dob = formatted;
                                                                setPatients(updatedPatients);
                                                            }}
                                                            className={patient.dobError ? "input-error" : ""}
                                                        />
                                                        {patient.dobError && (
                                                            <span style={{ color: "red", fontSize: "12px" }}>{patient.dobError}</span>
                                                        )}
                                                    </div>
                                                </td>

                                                <td title={patient.memberId || ""}>
                                                    <Input
                                                        type="text"
                                                        value={patient.memberId}
                                                        onChange={(e) => handleChange(index, "memberId", e.target.value)}
                                                        onPaste={(e) => handleColumnPaste(e, "memberId", index)}
                                                    />
                                                </td>
                                                <td title={patient.Provider_or_Company_name || ""}>
                                                    <Input
                                                        type="text"
                                                        value={patient.Provider_or_Company_name}
                                                        onChange={(e) => handleChange(index, "Provider_or_Company_name", e.target.value)}
                                                        onPaste={(e) => handleColumnPaste(e, "Provider_or_Company_name", index)}
                                                    />
                                                </td>

                                                <td title={patient.providerNpi || ""}>
                                                    <Input
                                                        type="text"
                                                        value={patient.providerNpi}
                                                        onChange={(e) => handleChange(index, "providerNpi", e.target.value)}
                                                        onPaste={(e) => handleColumnPaste(e, "providerNpi", index)}
                                                    />
                                                </td>

                                                <td title={patient.providerTaxid || ""}>
                                                    <Input
                                                        type="text"
                                                        value={patient.providerTaxid}
                                                        onChange={(e) => handleChange(index, "providerTaxid", e.target.value)}
                                                        onPaste={(e) => handleColumnPaste(e, "providerTaxid", index)}
                                                    />
                                                </td>
                                                {/* New City Field */}
                                                <td title={patient.city || ""}>
                                                    <Input
                                                        type="text"
                                                        value={patient.city}
                                                        onChange={(e) => handleChange(index, "city", e.target.value)}
                                                        onPaste={(e) => handleColumnPaste(e, "city", index)}
                                                        placeholder=""
                                                    />
                                                </td>

                                                {/* New State Field */}
                                                <td title={patient.state || ""}>
                                                    <Input
                                                        type="text"
                                                        value={patient.state}
                                                        onChange={(e) => handleChange(index, "state", e.target.value)}
                                                        onPaste={(e) => handleColumnPaste(e, "state", index)}
                                                        placeholder=""
                                                    />
                                                </td>

                                                {/* New Zip Code Field */}
                                                <td title={patient.postalCode || ""}>
                                                    <Input
                                                        type="text"
                                                        value={patient.postalCode}
                                                        onChange={(e) => handleChange(index, "postalCode", e.target.value)}
                                                        onPaste={(e) => handleColumnPaste(e, "postalCode", index)}
                                                        placeholder=""
                                                    />
                                                </td>
                                                {/* New Facility Field */}
                                                <td title={patient.facility || ""}>
                                                    <Input
                                                        type="text"
                                                        value={patient.facility}
                                                        onChange={(e) => handleChange(index, "facility", e.target.value)}
                                                        onPaste={(e) => handleColumnPaste(e, "facility", index)}
                                                        placeholder=""
                                                    />
                                                </td>
                                                <td style={{ minWidth: "150px" }} title={patient.type || ""}>
                                                    <div onPaste={(e) => handleColumnPaste(e, "type", index)}>
                                                        <Select
                                                            isClearable
                                                            options={typeOptions}
                                                            value={typeOptions.find(option => option.value === patient.type)}
                                                            onChange={(selectedOption) => handleChange(index, "type", selectedOption?.value || "")}
                                                            isSearchable
                                                            placeholder="Select Type"
                                                            styles={{ control: (base) => ({ ...base, minHeight: "38px", fontSize: "14px" }) }}
                                                        />
                                                    </div>
                                                </td>
                                                <td title={patient.subscriberFirstName || ""}>
                                                    <Input
                                                        type="text"
                                                        value={patient.subscriberFirstName || ""}
                                                        onChange={(e) => handleChange(index, "subscriberFirstName", e.target.value)}
                                                        onPaste={(e) => handleColumnPaste(e, "subscriberFirstName", index)}
                                                    />
                                                </td>
                                                <td title={patient.subscriberLastName || ""}>
                                                    <Input
                                                        type="text"
                                                        value={patient.subscriberLastName || ""}
                                                        onChange={(e) => handleChange(index, "subscriberLastName", e.target.value)}
                                                        onPaste={(e) => handleColumnPaste(e, "subscriberLastName", index)}
                                                    />
                                                </td>
                                                <td title={patient.subscriberDob || ""}>
                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        <Input
                                                            mask="99/99/9999"
                                                            type="text"
                                                            value={patient.subscriberDob || ""}
                                                            placeholder="MM/DD/YYYY"
                                                            onChange={(e) => {
                                                                const newSubscriberDob = e.target.value;
                                                                const updatedPatients = [...patients];
                                                                updatedPatients[index].subscriberDob = newSubscriberDob;
                                                                updatedPatients[index].subscriberDobError = ""; // Clear error on type
                                                                setPatients(updatedPatients);
                                                            }}
                                                            onBlur={(e) => {
                                                                const inputDate = e.target.value;
                                                                const formats = ["MM/DD/YYYY", "YYYY/MM/DD", "DD/MM/YYYY", "MM-DD-YYYY", "M-D-YYYY", "M/D/YYYY"];
                                                                const formattedDate = moment(inputDate, formats, true);

                                                                const updatedPatients = [...patients];
                                                                if (!formattedDate.isValid()) {
                                                                    updatedPatients[index].subscriberDobError = "Invalid date format. Use MM/DD/YYYY.";
                                                                    updatedPatients[index].subscriberDob = "";
                                                                } else if (formattedDate.isAfter(moment(), "day")) {
                                                                    updatedPatients[index].subscriberDobError = "Date of birth cannot be in the future.";
                                                                    updatedPatients[index].subscriberDob = "";
                                                                } else {
                                                                    updatedPatients[index].subscriberDobError = "";
                                                                    updatedPatients[index].subscriberDob = formattedDate.format("MM/DD/YYYY");
                                                                }
                                                                setPatients(updatedPatients);
                                                            }}
                                                            onFocus={() => {
                                                                setSelectedColumn("subscriberDob");
                                                            }}
                                                            onPaste={(e) => {
                                                                e.preventDefault();
                                                                const pasted = e.clipboardData.getData("text");
                                                                const formats = ["MM/DD/YYYY", "YYYY/MM/DD", "DD/MM/YYYY", "MM-DD-YYYY", "M-D-YYYY", "M/D/YYYY"];
                                                                const formattedDate = moment(pasted, formats, true);

                                                                const updatedPatients = [...patients];
                                                                if (!formattedDate.isValid()) {
                                                                    updatedPatients[index].subscriberDobError = "Invalid date format. Use MM/DD/YYYY.";
                                                                } else if (formattedDate.isAfter(moment(), "day")) {
                                                                    updatedPatients[index].subscriberDobError = "Date of birth cannot be in the future.";
                                                                } else {
                                                                    updatedPatients[index].subscriberDobError = "";
                                                                    updatedPatients[index].subscriberDob = formattedDate.format("MM/DD/YYYY");
                                                                }
                                                                setPatients(updatedPatients);
                                                            }}
                                                            className={patient.subscriberDobError ? "input-error" : ""}
                                                        />
                                                        {patient.subscriberDobError && (
                                                            <span style={{ color: "red", fontSize: "12px" }}>{patient.subscriberDobError}</span>
                                                        )}
                                                    </div>
                                                </td>
                                                <td title={patient.subscriberMemberId || ""}>
                                                    <Input
                                                        type="text"
                                                        value={patient.subscriberMemberId || ""}
                                                        onChange={(e) => handleChange(index, "subscriberMemberId", e.target.value)}
                                                        onPaste={(e) => handleColumnPaste(e, "subscriberMemberId", index)}
                                                    />
                                                </td>
                                                {/* <td style={{ minWidth: "50px" }}>
                                            <Input
                                                type="text"
                                                value={patient.location}
                                                onChange={(e) => handleChange(index, "location", e.target.value)}
                                                onPaste={(e) => handleColumnPaste(e, "location", index)}
                                            />
                                        </td> */}
                                                <td style={{ minWidth: "150px" }} title={patient.InsuranceNetwork || ""}>
                                                    <Input
                                                        type="text"
                                                        value={patient.InsuranceNetwork}
                                                        onChange={(e) => handleChange(index, "InsuranceNetwork", e.target.value)}
                                                        onPaste={(e) => { e.stopPropagation(); handleColumnPaste(e, "InsuranceNetwork", index); }}
                                                    />
                                                </td>
                                                <td style={{ minWidth: "150px" }} title={patient.feeSchedule || ""}>
                                                    <div onPaste={(e) => { e.stopPropagation(); handleColumnPaste(e, "feeSchedule", index); }}>
                                                        <Select
                                                            isClearable
                                                            options={feeScheduleOptions}
                                                            value={feeScheduleOptions.find(option => option.value === patient.feeSchedule)}
                                                            onChange={(selectedOption) => handleChange(index, "feeSchedule", selectedOption?.value || "")}
                                                            isSearchable
                                                            placeholder="Fee Schedule"
                                                            styles={{ control: (base) => ({ ...base, minHeight: "38px", fontSize: "14px" }) }}
                                                        />
                                                    </div>
                                                    {patient.feeScheduleInvalid && (
                                                        <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                                                            Invalid Fee Schedule: {patient.feeScheduleInvalid}
                                                        </div>
                                                    )}
                                                </td>
                                                <td style={{ maxWidth: "5px" }}>
                                                    <i
                                                        className="fa fa-times-circle-o cursor-pointer"
                                                        title="Clear"
                                                        onClick={() => removeRow(index)}
                                                        style={{ fontSize: '25px', color: 'red', cursor: 'pointer' }}
                                                    ></i>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className='enter_paitent_btn'>
                        <div>
                            <Button color="primary" onClick={() => isDynamicRpaMode ? handleDynamicAddRow() : addRows(1)} >Add New Rows</Button>
                        </div>
                        <br />
                        <div style={{ display: "flex", gap: "20px" }}>
                            <Button color="success" onClick={() => handlebulkentrysave()}>Save</Button>
                            <Button color="secondary" onClick={toggleModal}>Close</Button>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>

            <div>
                <Modal
                    style={{ maxWidth: "1700px", maxHeight: "1000px" }}
                    isOpen={scrollInnerModal}
                    toggle={() => setScrollInnerModal(!scrollInnerModal)}
                    className="modal-dialog-centered modal-lg"
                >
                    <ModalHeader toggle={() => setScrollInnerModal(!scrollInnerModal)}>
                        Bulk Upload Audit Log
                    </ModalHeader>
                    <ModalBody>
                        <div style={{ maxHeight: "600px", overflow: "auto" }}>
                            {filteredAuditData.filter((d: AuditData) => d.Action === "bulk_upload" || d.Action === "otp_update").length > 0 ? (
                                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                    <thead>
                                        <tr style={{ backgroundColor: "#f2f2f2" }}>
                                            <th className="audit-tableHeaderStyle">Date & Time</th>
                                            <th className="audit-tableHeaderStyle">Action</th>
                                            <th className="audit-tableHeaderStyle">Data Set</th>
                                            <th className="audit-tableHeaderStyle">Changed By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(() => {
                                            // Step 1: filter only bulk_upload
                                            const bulkUploadData = filteredAuditData.filter(
                                                (d: AuditData) =>
                                                    d.Action === "bulk_upload" &&
                                                    d.JsonData &&
                                                    typeof d.JsonData === "object" &&
                                                    !Array.isArray(d.JsonData)
                                            );

                                            // Step 2: group by Parentid
                                            const groupedByParent: Record<string, AuditData[]> = {};
                                            bulkUploadData.forEach((d) => {
                                                const parentId = (d.JsonData as any).Parentid || d.Parentid || "NO_PARENT";
                                                if (!groupedByParent[parentId]) groupedByParent[parentId] = [];
                                                groupedByParent[parentId].push(d);
                                            });

                                            // Step 3: render grouped sections
                                            return Object.entries(groupedByParent).map(([parentId, rows], idx) => {
                                                // Collect all unique keys across JsonData rows (for array of JsonData)
                                                const allKeys = Array.from(
                                                    new Set(
                                                        rows.flatMap((r) =>
                                                            Array.isArray(r.JsonData)
                                                                ? r.JsonData.map((jd) => jd.field)
                                                                : Object.keys(r.JsonData as Record<string, unknown>)
                                                        )
                                                    )
                                                ).sort((a, b) => {
                                                    const rankA = getAuditFieldRank(a);
                                                    const rankB = getAuditFieldRank(b);
                                                    return rankA - rankB;
                                                });

                                                const tableHeaderStyle: React.CSSProperties = {
                                                    backgroundColor: "#e9ecef",
                                                    fontWeight: "bold",
                                                    padding: "6px",
                                                };
                                                const tableDataStyle: React.CSSProperties = {
                                                    padding: "6px",
                                                    verticalAlign: "middle",
                                                };

                                                // Use first row's meta (Date/UserName) since Parentid is same
                                                const localDate = moment
                                                    .utc(rows[0].Modified)
                                                    .tz(moment.tz.guess())
                                                    .format("MM/DD/YYYY hh:mm:ss A");

                                                return (
                                                    <tr key={idx}>
                                                        <td className="audit-tableDataStyle">{localDate}</td>
                                                        <td className="audit-tableDataStyle">bulk_upload</td>
                                                        <td className="audit-tableDataStyle">
                                                            <Table bordered size="sm">
                                                                <thead>
                                                                    <tr>
                                                                        <th style={tableHeaderStyle}>#</th>
                                                                        {allKeys.map((key) => (
                                                                            <th key={key} style={tableHeaderStyle}>
                                                                                {key}
                                                                            </th>
                                                                        ))}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {rows.map((r, rowIdx) => (
                                                                        <tr key={rowIdx}>
                                                                            <td style={tableDataStyle}>{rowIdx + 1}</td>
                                                                            {allKeys.map((key) => (
                                                                                <td key={key} style={tableDataStyle}>
                                                                                    {(r.JsonData as any)[key] ?? ""}
                                                                                </td>
                                                                            ))}
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </td>
                                                        <td className="audit-tableDataStyle">{rows[0].UserName}</td>
                                                    </tr>
                                                );
                                            });
                                        })()}
                                        {/* OTP updates entered from the OTP popup */}
                                        {filteredAuditData
                                            .filter((d: AuditData) => d.Action === "otp_update" && d.JsonData && typeof d.JsonData === "object" && !Array.isArray(d.JsonData))
                                            .sort((a: AuditData, b: AuditData) => moment.utc(a.Modified, "MM/DD/YYYY HH:mm:ss").valueOf() - moment.utc(b.Modified, "MM/DD/YYYY HH:mm:ss").valueOf())
                                            .map((r: AuditData, idx: number) => {
                                                const otpKeys = Object.keys(r.JsonData as unknown as Record<string, unknown>);
                                                return (
                                                    <tr key={`otp-${idx}`}>
                                                        <td className="audit-tableDataStyle">
                                                            {moment.utc(r.Modified).tz(moment.tz.guess()).format("MM/DD/YYYY hh:mm:ss A")}
                                                        </td>
                                                        <td className="audit-tableDataStyle">otp_update</td>
                                                        <td className="audit-tableDataStyle">
                                                            <Table bordered size="sm">
                                                                <thead>
                                                                    <tr>
                                                                        {otpKeys.map((key) => (
                                                                            <th key={key} style={{ backgroundColor: "#e9ecef", fontWeight: "bold", padding: "6px" }}>
                                                                                {key}
                                                                            </th>
                                                                        ))}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        {otpKeys.map((key) => (
                                                                            <td key={key} style={{ padding: "6px", verticalAlign: "middle" }}>
                                                                                {(r.JsonData as any)[key] ?? ""}
                                                                            </td>
                                                                        ))}
                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                        </td>
                                                        <td className="audit-tableDataStyle">{r.UserName}</td>
                                                    </tr>
                                                );
                                            })}
                                    </tbody>
                                </table>
                            ) : (
                                <div>
                                    <center>No bulk upload data available</center>
                                </div>
                            )}
                        </div>
                    </ModalBody>
                </Modal>

            </div>
        </Fragment>
    );
}

export default Bulkupload;
